import React, {Component, useEffect, useState} from 'react';
import {
    Button,
    Checkbox,
    Col,
    Form,
    FormControl,
    FormGroup,
    Image,
    InputGroup,
    ListGroup,
    ListGroupItem,
    Nav,
    NavItem,
    OverlayTrigger,
    Panel,
    Popover,
    Row,
    Tab,
    DropdownButton, MenuItem
} from 'react-bootstrap';
import Select from 'react-select';
import {SketchPicker} from 'react-color';
import Colour_Picker from '../../components/Colour_Picker';
import reactCSS from 'reactcss';
import {Redirect, withRouter} from 'react-router-dom'
import {connect} from 'react-redux';
import {toastr} from 'react-redux-toastr'
import InfiniteScroll from "react-infinite-scroll-component";
import Autosuggest from 'react-autosuggest';
import TagsInput from 'react-tagsinput';
import 'react-tagsinput/react-tagsinput.css';

import {
    check_permission,
    create_order,
    fetch_design_template,
    fetch_saved_design,
    fetch_text_template,
    fetch_user_uploads,
    share_permission_with_emails,
    update_design_name,
    upload_user_file
} from './actions'
import {calculate_price} from '../MockupPage/actions';
import DesignResourcesPanel from '../../components/designResourcesPanel';
import ElementsPanel from '../../components/ElementsPanel';
import tooltips from '../../components/Tooltips';

import ImageMakerPanel from '../../components/ImageMakerPanel';
// import RfImagePanel from '../../components/RfImagePanel';
// import PixlrPanel from '../../components/PixlrPanel';
import BackgroundPanel from '../../components/BackgroundPanel';
import TemplatesPanel from '../../components/TemplatesPanel';
import FontsPanel from '../../components/FontsPanel';
import FoldersPanel from '../../components/FoldersPanel';
import MagicResizeModal from '../../components/MagicResizeModal';
import SuggestDesignsModal from '../../components/SuggestDesignsModal';

import Mobile_Deterrent from '../../views/MobileDeterrent';
import DesignSaveStatus from './DesignSaveStatus.js';
import LabellingToolBar from './LabellingToolbar.js';
import GroupOptionsPanel from './GroupOptionsPanel.js';
import ImageOptionsPanel from './ImageOptionsPanel.js';
import TextOptionsPanel from './TextOptionsPanel.js';
import BackgroundOptionsPanel from './BackgroundOptionsPanel';
import CanvasPages from './canvasPages';
import AdjustmentPanel from "./AdjustmentPanel";
import TextEffectsPanel from "./TextEffectsPanel";
import BackgroundRemovalPanel from "./BackgroundRemovalPanel";
import MockupEditorPanel from "./MockupEditorPanel";
import {designFilters} from './filters';
import MockupsPanel from './mockups_panel';
import BrandKitPanel from './brand_kit_panel';
import Switcher from '../../components/Switcher';
import CopyLinkContainer from '../../components/CopyLinkContainer';

import './style.css';
import {hasAutoSuggestPerm, hasMagicResizePerm} from "../../utils/subscriptionUtils";
import {SubscriptionModal} from "../../components/SubscriptionModal";
import PurchaseModal from "../../components/PurchaseModal";
import ManateeDropdown from '../../components/ManateeDropdown';
import ContextMenu from '../../components/contextMenu';

import {Fetch} from '../../utils';
import UnifiedCheckoutModal from "../../components/UnifiedCheckoutModal";
import BulkEditPanel from "../../components/BulkEditPanel";
import AnimationsPanel from "./AnimationsPanel";
import ShareLinkModal from '../../components/ShareLinkModal';
import {DMPlayerModal} from "../../components/DMPlayer";
import ShadowsPanel from "./ShadowsPanel";
import { delete_folder_resource } from '../Folders/actions';

const { feline_fetch } = Fetch;

const default_dimensions = require('./dimensions.json');
const fontSizeOptions = require('./fontSizeOptions.json');

const fontStyles = {
    control: (provided) => {
        return {...provided,marginLeft:'5px', minWidth:'50px',height:'36px',minHeight:'20px',marginRight: '5px'}
    },
    dropdownIndicator: (provided) => {
        return {...provided, display:'none'}
    }
};

function capFirst(string) {
    string = string.replace('_',' ');
    var split = string.split(' ');
    var new_string = '';
    for(var n=0;n<split.length;n++){
        new_string += split[n].charAt(0).toUpperCase() + split[n].slice(1).toLowerCase();
        if(n!=split.length-1){
            new_string += ' '
        }
    }
    return new_string
}

const load_font = async ({ name, src, url }) => {
    try {
        if (!url && !src) {
            throw 'no font src provided';
        }
        var file_path = 'url(' + (url ? url : (global.config.server_path + src)) + ')';
        var custom_font = new FontFace(name, file_path);
        var loaded_face = await custom_font.load()
        document.fonts.add(loaded_face);
        document.body.style.fontFamily = '"' + name + '", Arial';
    } catch(err) {
        console.log('error loading font --> ', err);
    }
}

var default_drag_ghost = new window.Image();
default_drag_ghost.id = 'drag_image';
default_drag_ghost.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=';


class Designs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            design: null,
            brandkit_font_sets: [],
            brandkit_color_palettes: [],
            discount: 0,
            coupon_applied: false,
            coupon_code: null,
            apply_brand_kit: false,
            templates : [],
            uploads: [],
            user_details: null,
            design_selection: null,
            toolbar_type: null,
            label_rules: null,
            redirect: false,
            redirect_url: null,
            custom_upload: null,
            view_display_srcs: [],
            resize_dimensions: {},
            layer_buttons: {top:false,bottom:false},
            pages: 0,
            design_save_id: null,
            design_resources_text_templates: {
                data : [],
                page_no: 0,
            },
            share_emails: [],
            share_role: 'view',
            last_email: '',
            collapse_sidebar: false,
            active_nav_tab: 'templates',
            previous_nav_tab: 'templates',
            page_zoom_display: 'Fit',
            crop_mode: false,
            displayGridColorPicker: false,
            designName : '',
            full_page_loader: false,
            full_page_loader_message: 'Saving your work, it should take only a few seconds ...',
            active_payment_tab: null,
            activePhotoTab : 1,
            activeBackgroundTab : 0, // 0:1
            activeMockupTab : 1,
            saved_mockups: [],
            search_active : false,
            search_results : [],
            search_results_display : [],
            search_text : '',
            show_magic_resize_modal : false,
            show_suggest_design_modal : false,
            defaultCategory: null,
            filterIntensity: 50,
            displaySubscriptionModal: false,
            showPurchaseModal: false,
            showUnifiedCheckoutModal: false,
            checkoutUrl: null,
            designIsLoaded: false,
            //hover flags --- to be deprecated
            hoverable_icon_template: false,
            hoverable_icon_photo: false,
            hoverable_icon_background: false,
            hoverable_icon_text: false,
            hoverable_icon_element: false,
            hoverable_icon_mockup: false,
            hoverable_icon_folder: false,
            hoverable_icon_brand_kit: false,
            hoverable_icon_bulk_edit: false,
            device_type: 'desktop',
            photos_subscription: false,
            enable_share_switch_for_view: false,
            enable_share_switch_for_edit: false,
            link_sharing_enabled: false,
            show_share_modal: false,
            display_animations_player_modal: false,
            grid_bulk_edit_label_temp: '',
            grid_bulk_edit_open: false
        };

        this.adjustmentPanelRef = React.createRef();
        this.textEffectsPanelRef = React.createRef();
        this.backgroundRemovalPanelRef = React.createRef();
        this.mockupEditorPanelRef = React.createRef();
    }

    generate_thumbnails_context_menu = (resource) => {
        console.log('called asdfadsfs')
        let resource_path = null;
        if (resource._id) resource_path = resource._id;
        else if (resource.src) resource_path = resource.src;


        const designs_context_menu = [
            {
                'name': 'Delete',
                'action': (e => {
                    this.delete_folder_resource(resource_path);
                })
            }
        ];

        return (<ContextMenu contextMenuName="your-designs-context-menu" contextMenuOptions={designs_context_menu}/>)
    };

    delete_folder_resource = (resource_id) => {
        try {
            delete_folder_resource(this.props.user.my_photos_folder, resource_id)
            .then(() => this.fetch_user_uploads())
            .catch(err => Promise.reject(err))
        } catch(err) {
            console.error(err);
        }
    }

    update_window_size = () => {
        if (window.innerWidth > 767) {
            this.setState({ device_type: 'desktop'});
        } else {
            this.setState({ device_type: 'tablet'});
        }
    }

    setDesignLoaded = () => {
        this.setState({
            designIsLoaded: true
        })
    };

    hidePurchaseModal = () => {
        this.refs.purchase_modal_overlay.hide();
        this.setState({
            showPurchaseModal: false
        })
    };

    closeAnimationsPlayerModal = () => {
        this.setState({
            display_animations_player_modal : false
        })
    };

    hideUnifiedCheckoutModal = () => {
        this.setState({showUnifiedCheckoutModal: false})
    };

    setSubscriptionModalDisplay = (value) => {
        this.setState({
            displaySubscriptionModal : value
        })
    };

    hide_suggest_design_modal = () => {
        this.setState({show_suggest_design_modal : false})
    }

    hide_magic_resize_modal = () => {
        this.setState({show_magic_resize_modal : false})
    }

    handle_share_emails = share_emails => {
        this.setState({share_emails:share_emails,last_email: ''})
    }

    handle_last_email = input => {
        this.setState({last_email: input})
    }

    redirect_page = (url) => {
        this.setState({redirect_url:url,redirect:true})
    }

    inmagine_login = () => {
        window.localStorage.setItem('last_url', window.location.href);
        if (!this.props.user) {
            window.localStorage.setItem('unsaved_design_id', this.props.match.params.design_id);
        }
        window.location.href= global.config.designs_ai_server_path + "user/sign-in?c="+global.config.dm_client_id+"&r=" + global.config.auth_redirect_path_dm;
    }

    set_default_category = (category_id) => this.setState({defaultCategory: category_id})
    set_view_display_src = (srcs) => this.setState({view_display_srcs:srcs})

    rct_update_pages = (count) => this.set_state({pages: count})

    adjustmentPanelOnclick = () => {
        this.switch_nav_tab("adjust")
        .then(() => {
            if(this.state.design_selection){
                var filter
                if(this.state.design_selection.get_parent('grid')){
                    if(this.state.design_selection.get_parent('box') && this.state.design_selection.get_parent('box').image){
                        filter = this.state.design_selection.get_parent('box').image.filter
                    }
                }else if(this.state.design_selection.type === 'image'){
                    filter = this.state.design_selection.filter
                }
            }else if(this.state.toolbar_type=='background'){
                filter = window.design_editor.active_page.background.filter
            }

            if(filter && this.adjustmentPanelRef && this.adjustmentPanelRef.current){
                this.adjustmentPanelRef.current.updateFields(filter)
            }
        })
            
    }

    shadowsPanelOnClick = () => {
        console.log("yeah")
        this.switch_nav_tab("shadows")
        .then(() => {
            // let shadow = null;
            // if(this.state.design_selection){
            //     if(this.state.design_selection.get_parent('grid')){
            //         if(this.state.design_selection.get_parent('box') && this.state.design_selection.get_parent('box').image){
            //             shadow = this.state.design_selection.get_parent('box').image.filter
            //         }
            //     }else if(this.state.design_selection.type === 'image'){
            //         shadow = this.state.design_selection.filter
            //     }
            // }
            // if(shadow && this.adjustmentPanelRef && this.adjustmentPanelRef.current){
            //     this.adjustmentPanelRef.current.updateFields(shadow)
            // }
        })
    }

    textEffectsPanelOnclick = () => {
        this.switch_nav_tab("text_effects")
        .then(() => {
            if(this.state.design_selection && this.state.design_selection.type == 'text'){
                var text_details = this.state.design_selection.text_details;
            }

            if(text_details && this.textEffectsPanelRef && this.textEffectsPanelRef.current){
                this.textEffectsPanelRef.current.updateFields(text_details)
            }
        })
            
    }

    backgroundRemovalPanelOnclick = () => {
        this.switch_nav_tab("remove_background")
        .then(() => {
            if(this.state.design_selection){
                var bgremoval
                if(this.state.design_selection.get_parent('grid')){
                    if(this.state.design_selection.get_parent('box') && this.state.design_selection.get_parent('box').image){
                        bgremoval = this.state.design_selection.get_parent('box').image.bgremoval
                    }
                }else if(this.state.design_selection.type === 'image'){
                    bgremoval = this.state.design_selection.bgremoval
                }
            }else if(this.state.toolbar_type=='background'){
                bgremoval = window.design_editor.active_page.background.bgremoval
            }

            if(bgremoval && this.backgroundRemovalPanelRef && this.backgroundRemovalPanelRef.current){
                this.backgroundRemovalPanelRef.current.updateFields(bgremoval)
            }
        })
    }

    mockupEditorPanelOnclick = () => {
        this.switch_nav_tab("mockup_editor")
        .then(() => {
            if(this.state.design_selection){
                var mockup_details;
                var image_cache_id;
                if(this.state.design_selection.get_parent('grid')){
                    if(this.state.design_selection.get_parent('box') && this.state.design_selection.get_parent('box').image){
                        mockup_details = this.state.design_selection.get_parent('box').image.mockup_details;
                        image_cache_id = this.state.design_selection.get_parent('box').image.image_cache_id()
                    }
                }else if(this.state.design_selection.type === 'image'){
                    mockup_details = this.state.design_selection.mockup_details
                    image_cache_id = this.state.design_selection.image_cache_id();
                }
            }


            if(mockup_details && this.mockupEditorPanelRef && this.mockupEditorPanelRef.current){
                if(window.design_editor && window.design_editor.design.loaded_mockups[mockup_details.id]){
                    this.mockupEditorPanelRef.current.updateFields({
                        mockup: window.design_editor.design.loaded_mockups[mockup_details.id],
                        saved_mockup: {
                            mockup_inputs:mockup_details.inputs,
                            watermarked_output_src: window.design_editor.design.loaded_images[image_cache_id]?window.design_editor.design.loaded_images[image_cache_id].src:''
                        }
                    })
                }else{
                    window.design_editor.draw();
                    window.design_editor.design.wait_to_load()
                    .then(() => {
                        this.mockupEditorPanelRef.current.updateFields({
                            mockup: window.design_editor.design.loaded_mockups[mockup_details.id],
                            saved_mockup: {
                                mockup_inputs:mockup_details.inputs,
                                watermarked_output_src: window.design_editor.design.loaded_images[image_cache_id]?window.design_editor.design.loaded_images[image_cache_id].src:''
                            }
                        })
                    })                
                }
            }else{
                toastr.error('something went wrong')
            }
        })
    }

    add_image = (resource,event) => {
        function elseCase(){
            var aspect = event.target.clientWidth/event.target.clientHeight
            var width = window.design_editor.design.get_width()*400/800

            if(resource.id_imagemaker){
                var data = {
                    type: 'image',
                    image_details:{
                        id_imagemaker: resource.id_imagemaker,
                        image_width: width,
                        image_height: width/aspect
                    },
                    width:width,
                    height: width/aspect,
                    loader_image: event.target
                }
                if(resource.mockup_id && resource.inputs){
                    data.sub_type = 'mockup'
                    data.mockup_details = {
                        id: resource.mockup_id,
                        inputs: resource.inputs
                    }
                }
                window.design_editor.addObject(data)
            }else if(resource.id_123rf){
                var data = {
                    type: 'image',
                    image_details:{
                        id_123rf: resource.id_123rf,
                        image_width: width,
                        image_height: width/aspect
                    },
                    width:width,
                    height: width/aspect,
                    loader_image: event.target
                }
                if(resource.mockup_id && resource.inputs){
                    data.sub_type = 'mockup'
                    data.mockup_details = {
                        id: resource.mockup_id,
                        inputs: resource.inputs
                    }
                }
                window.design_editor.addObject(data)
            }else if(resource.id_123rf_plus){
                var data = {
                    type: 'image',
                    image_details:{
                        id_123rf_plus: resource.id_123rf_plus,
                        image_width: width,
                        image_height: width/aspect
                    },
                    width:width,
                    height: width/aspect,
                    loader_image: event.target
                }
                if(resource.mockup_id && resource.inputs){
                    data.sub_type = 'mockup'
                    data.mockup_details = {
                        id: resource.mockup_id,
                        inputs: resource.inputs
                    }
                }
                window.design_editor.addObject(data)
            }else if(resource.id_pixlr){
                var data = {
                    type: 'image',
                    image_details:{
                        id_pixlr: resource.id_pixlr,
                        image_width: width,
                        image_height: width/aspect
                    },
                    width:width,
                    height: width/aspect,
                    loader_image: event.target
                }
                if(resource.mockup_id && resource.inputs){
                    data.sub_type = 'mockup'
                    data.mockup_details = {
                        id: resource.mockup_id,
                        inputs: resource.inputs
                    }
                }
                window.design_editor.addObject(data)
            }else if(resource.id_unsplash){
                var data = {
                    type: 'image',
                    image_details:{
                        id_unsplash: resource.id_unsplash,
                        image_width: width,
                        image_height: width/aspect
                    },
                    width:width,
                    height: width/aspect,
                    loader_image: event.target
                }
                if(resource.mockup_id && resource.inputs){
                    data.sub_type = 'mockup'
                    data.mockup_details = {
                        id: resource.mockup_id,
                        inputs: resource.inputs
                    }
                }
                window.design_editor.addObject(data)
            }else if(resource.resource_id){
                var data = {
                    type: 'image',
                    image_details:{
                        resource_id: resource.resource_id,
                        image_width: width,
                        image_height: width/aspect
                    },
                    width:width,
                    height: width/aspect,
                    loader_image: event.target
                }
                if(resource.mockup_id && resource.inputs){
                    data.sub_type = 'mockup'
                    data.mockup_details = {
                        id: resource.mockup_id,
                        inputs: resource.inputs
                    }
                }
                window.design_editor.addObject(data)
            }else if(resource.src){
                var data = {
                    type: 'image',
                    image_details:{
                        src: resource.src,
                        image_width: width,
                        image_height: width/aspect
                    },
                    width:width,
                    height: width/aspect,
                    loader_image: event.target
                }
                if(resource.mockup_id && resource.inputs){
                    data.sub_type = 'mockup'
                    data.mockup_details = {
                        id: resource.mockup_id,
                        inputs: resource.inputs
                    }
                }
                window.design_editor.addObject(data)
            }
        }

        function set_new_image_details(image_details){
            image_details.id_imagemaker = '';
            image_details.id_123rf = '';
            image_details.id_123rf_plus = '';
            image_details.id_pixlr = '';
            image_details.id_unsplash = ''
            image_details.resource_id = ''
            image_details.src = ''
            image_details.image_contain = null

            if(resource.id_imagemaker){
                image_details.id_imagemaker = resource.id_imagemaker
            }else if(resource.id_123rf){
                image_details.id_123rf = resource.id_123rf
            }else if(resource.id_123rf_plus){
                image_details.id_123rf_plus = resource.id_123rf_plus
            }else if(resource.id_pixlr){
                image_details.id_pixlr = resource.id_pixlr
            }else if(resource.id_unsplash){
                image_details.id_unsplash = resource.id_unsplash
            }else if(resource.resource_id){
                image_details.resource_id = resource.resource_id
            }else if(resource.src){
                image_details.src = resource.src
            }

            image_details.image_needs_autoset = true
        }

      
        elseCase()
    }

    load_text_template = (template) => {
        var file_copy = JSON.parse(JSON.stringify(template.design_file));
        file_copy.group.id = window.utils.uuidv4();
        var id_mapping = {}
        for (let i = 0; i < file_copy.objects.length; i++) {
            let old_id = file_copy.objects[i].id
            file_copy.objects[i].id = window.utils.uuidv4();
            id_mapping[old_id] = file_copy.objects[i].id
        }
        for (let i = 0; i < file_copy.group.group_details.object_data.length; i++) {
            file_copy.group.group_details.object_data[i].object = id_mapping[file_copy.group.group_details.object_data[i].object]
        }

        file_copy.objects = file_copy.objects.sort(function(a,b){
            return a.layer_index - b.layer_index
        })

        window.design_editor.addGroup(file_copy,undefined,true)
    }

    text_template_drag_start = (template,event) => {
        return; //temp return
        var x,y;
        if(event.type == "touchmove"){
            x = event.touches[0].pageX;
            y = event.touches[0].pageY;
        }else{
            x = event.pageX;
            y = event.pageY;
        }

        var offset_x = (x - window.$(event.target).offset().left)
        var offset_y = (y - window.$(event.target).offset().top)


        event.dataTransfer.effectAllowed = 'move';
        event.target.style.opacity = 0

        event.dataTransfer.setDragImage(default_drag_ghost, 0, 0);

        window.design_editor.drag_ghost_image = event.target.cloneNode(true);
        window.design_editor.drag_ghost_image.style.opacity = 0.8
        window.document.body.appendChild(window.design_editor.drag_ghost_image)
        window.design_editor.drag_details = {
            offset_x: offset_x,
            offset_y: offset_y,
            raw_x: x,
            raw_y: y,
            previous_raw_x: x,
            previous_raw_y: y,
            original_width: event.target.clientWidth,
            original_height: event.target.clientHeight,
            drag_type: 'text_template',
            data: {type:'text_template',data:template}
        }
    }

    text_template_drag = (template,event) => {
        return; //temp return
        var x,y;
        if(event.type == "touchmove"){
            x = event.touches[0].pageX;
            y = event.touches[0].pageY;
        }else{
            x = event.pageX;
            y = event.pageY;
        }
        if(window.design_editor.drag_details){
            window.design_editor.drag_details.raw_x = window.design_editor.drag_details.previous_raw_x
            window.design_editor.drag_details.raw_y = window.design_editor.drag_details.previous_raw_y
            window.design_editor.drag_details.previous_raw_x = x
            window.design_editor.drag_details.previous_raw_y = y
        }

        window.design_editor.style_ghost_image(event.target);

        event.preventDefault();
    }

    text_template_drag_end = (template,event) => {
        return; //temp return
        event.target.style.opacity = 1
        var elem = window.document.getElementById('drag_image');
        if(elem && elem.parentElement){
            elem.parentElement.removeChild(elem);
        }
        if(window.design_editor.drag_ghost_image && window.design_editor.drag_ghost_image.parentElement){
            window.design_editor.drag_ghost_image.parentElement.removeChild(window.design_editor.drag_ghost_image);
        }

        window.design_editor.handleDrop(event.target);
        // window.design_editor.drag_ghost_image = null;
        // window.design_editor.drag_details = null;
        event.preventDefault();
    }

    load_text = (template,event) => {
        window.design_editor.addObject(template.design_file)
    }

    text_drag_start = (template,event) => {
        return; //temp return
        var x,y;
        if(event.type == "touchmove"){
            x = event.touches[0].pageX;
            y = event.touches[0].pageY;
        }else{
            x = event.pageX;
            y = event.pageY;
        }

        var offset_x = (x - window.$(event.target).offset().left)
        var offset_y = (y - window.$(event.target).offset().top)


        event.dataTransfer.effectAllowed = 'move';
        event.target.style.opacity = 0

        event.dataTransfer.setDragImage(default_drag_ghost, 0, 0);

        window.design_editor.drag_ghost_image = event.target.cloneNode(true);
        window.design_editor.drag_ghost_image.style.opacity = 0.8
        window.document.body.appendChild(window.design_editor.drag_ghost_image)
        window.design_editor.drag_details = {
            offset_x: offset_x,
            offset_y: offset_y,
            raw_x: x,
            raw_y: y,
            previous_raw_x: x,
            previous_raw_y: y,
            original_width: event.target.clientWidth,
            original_height: event.target.clientHeight,
            drag_type: 'text',
            data: {type:'text',data:template.design_file}
        }
    }

    text_drag = (template,event) => {
        return; //temp return
        var x,y;
        if(event.type == "touchmove"){
            x = event.touches[0].pageX;
            y = event.touches[0].pageY;
        }else{
            x = event.pageX;
            y = event.pageY;
        }
        if(window.design_editor.drag_details){
            window.design_editor.drag_details.raw_x = window.design_editor.drag_details.previous_raw_x
            window.design_editor.drag_details.raw_y = window.design_editor.drag_details.previous_raw_y
            window.design_editor.drag_details.previous_raw_x = x
            window.design_editor.drag_details.previous_raw_y = y
        }

        window.design_editor.style_ghost_image(event.target);

        event.preventDefault();
    }

    text_drag_end = (template,event) => {
        return; //temp return
        event.target.style.opacity = 1
        var elem = window.document.getElementById('drag_image');
        if(elem && elem.parentElement){
            elem.parentElement.removeChild(elem);
        }
        if(window.design_editor.drag_ghost_image && window.design_editor.drag_ghost_image.parentElement){
            window.design_editor.drag_ghost_image.parentElement.removeChild(window.design_editor.drag_ghost_image);
        }

        window.design_editor.handleDrop(event.target);
        // window.design_editor.drag_ghost_image = null;
        // window.design_editor.drag_details = null;
        event.preventDefault();
    }

    image_drag_start = (resource,event) => {
        return; //temp return
        var x,y;
        if(event.type == "touchmove"){
            x = event.touches[0].pageX;
            y = event.touches[0].pageY;
        }else{
            x = event.pageX;
            y = event.pageY;
        }

        var offset_x = (x - window.$(event.target).offset().left)
        var offset_y = (y - window.$(event.target).offset().top)


        event.dataTransfer.effectAllowed = 'move';
        event.target.style.opacity = 0

        event.dataTransfer.setDragImage(default_drag_ghost, 0, 0);

        window.design_editor.drag_ghost_image = event.target.cloneNode(true);
        window.design_editor.drag_ghost_image.crossOrigin = 'anonymous'
        window.design_editor.drag_ghost_image.style.opacity = 0.8
        window.document.body.appendChild(window.design_editor.drag_ghost_image)
        window.design_editor.drag_details = {
            offset_x: offset_x,
            offset_y: offset_y,
            raw_x: x,
            raw_y: y,
            previous_raw_x: x,
            previous_raw_y: y,
            original_width: event.target.clientWidth,
            original_height: event.target.clientHeight,
            drag_type: 'image',
            data: {type:'image',data:resource}
        }
    }

    image_drag = (resource,event) => {
        return; //temp return
        var x,y;
        if(event.type == "touchmove"){
            x = event.touches[0].pageX;
            y = event.touches[0].pageY;
        }else{
            x = event.pageX;
            y = event.pageY;
        }
        if(window.design_editor.drag_details){
            window.design_editor.drag_details.raw_x = window.design_editor.drag_details.previous_raw_x
            window.design_editor.drag_details.raw_y = window.design_editor.drag_details.previous_raw_y
            window.design_editor.drag_details.previous_raw_x = x
            window.design_editor.drag_details.previous_raw_y = y
        }

        window.design_editor.style_ghost_image(event.target);

        event.preventDefault();
    }

    image_drag_end = (resource,event) => {
        return; //temp return
        event.target.style.opacity = 1
        var elem = window.document.getElementById('drag_image');
        if(elem && elem.parentElement){
            elem.parentElement.removeChild(elem);
        }
        if(window.design_editor.drag_ghost_image && window.design_editor.drag_ghost_image.parentElement){
            window.design_editor.drag_ghost_image.parentElement.removeChild(window.design_editor.drag_ghost_image);
        }

        window.design_editor.handleDrop(event.target);
        // window.design_editor.drag_ghost_image = null;
        // window.design_editor.drag_details = null;
        event.preventDefault();
    }

    load_background = (resource,event) => {
        window.design_editor.active_page.background.reset_image_source();
        window.design_editor.active_page.background.image_details.image_contain = null;
        
        if(resource.id_imagemaker){
            window.design_editor.active_page.background.image_details.id_imagemaker = resource.id_imagemaker
        }else if(resource.id_123rf){
            window.design_editor.active_page.background.image_details.id_123rf = resource.id_123rf
        }else if(resource.id_123rf_plus){
            window.design_editor.active_page.background.image_details.id_123rf_plus = resource.id_123rf_plus
        }else if(resource.id_pixlr){
            window.design_editor.active_page.background.image_details.id_pixlr = resource.id_pixlr
        }else if(resource.id_unsplash){
            window.design_editor.active_page.background.image_details.id_unsplash = resource.id_unsplash
        }else if(resource.resource_id){
            window.design_editor.active_page.background.image_details.resource_id = resource.resource_id
        }else if(resource.src){
            window.design_editor.active_page.background.image_details.src = resource.src
        }

        window.design_editor.active_page.background.image_details.filter = null
        window.design_editor.active_page.background.reset_filter()
        window.design_editor.active_page.background.reset_bgremoval()

        window.design_editor.active_page.background.sub_type = null

        // Uncomment this line if you want the clicked image to be registered as the background's loader_image.
        // Note: If uncommented, it may cause the image to disappear due to other logic in the editor
        // but the loader_images not show as expected,
        
        // window.design_editor.active_page.background.loader_image = event.target
        window.design_editor.active_page.background.image_details.image_needs_autoset = true;
        window.design_editor.active_page.background.set_redraw()
        window.design_editor.needs_redraw = true
        window.design_editor.addUndoChange()
    }

    background_drag_start = (resource,event) => {
        return; //temp return
        var x,y;
        if(event.type == "touchmove"){
            x = event.touches[0].pageX;
            y = event.touches[0].pageY;
        }else{
            x = event.pageX;
            y = event.pageY;
        }

        var offset_x = (x - window.$(event.target).offset().left)
        var offset_y = (y - window.$(event.target).offset().top)


        event.dataTransfer.effectAllowed = 'move';
        event.target.style.opacity = 0

        event.dataTransfer.setDragImage(default_drag_ghost, 0, 0);

        window.design_editor.drag_ghost_image = event.target.cloneNode(true);
        window.design_editor.drag_ghost_image.style.opacity = 0.8
        window.document.body.appendChild(window.design_editor.drag_ghost_image)
        window.design_editor.drag_details = {
            offset_x: offset_x,
            offset_y: offset_y,
            raw_x: x,
            raw_y: y,
            previous_raw_x: x,
            previous_raw_y: y,
            original_width: event.target.clientWidth,
            original_height: event.target.clientHeight,
            drag_type: 'background',
            data: {type:'background',data:resource}
        }
    }

    background_drag = (resource,event) => {
        return; //temp return
        var x,y;
        if(event.type == "touchmove"){
            x = event.touches[0].pageX;
            y = event.touches[0].pageY;
        }else{
            x = event.pageX;
            y = event.pageY;
        }
        if(window.design_editor.drag_details){
            window.design_editor.drag_details.raw_x = window.design_editor.drag_details.previous_raw_x
            window.design_editor.drag_details.raw_y = window.design_editor.drag_details.previous_raw_y
            window.design_editor.drag_details.previous_raw_x = x
            window.design_editor.drag_details.previous_raw_y = y
        }

        window.design_editor.style_ghost_image(event.target);

        event.preventDefault();
    }

    background_drag_end = (resource,event) => {
        return; //temp return
        event.target.style.opacity = 1
        var elem = window.document.getElementById('drag_image');
        if(elem && elem.parentElement){
            elem.parentElement.removeChild(elem);
        }
        if(window.design_editor.drag_ghost_image && window.design_editor.drag_ghost_image.parentElement){
            window.design_editor.drag_ghost_image.parentElement.removeChild(window.design_editor.drag_ghost_image);
        }

        window.design_editor.handleDrop(event.target);
        // window.design_editor.drag_ghost_image = null;
        // window.design_editor.drag_details = null;
        event.preventDefault();
    }

    post_design_selection = (dont_add_undo) => {
        // if(!dont_add_undo){
            window.design_editor.addUndoChange()
        // }
        window.design_editor.needs_redraw = true;
    }

    set_state = async state => new Promise(resolve => this.setState(state, resolve));

    update_inputs_text = (value,type) => {
        var design_selection = this.state.design_selection
        if(type=='font'){
            design_selection.text_details.font = value.value
            design_selection.text_details.font_src = value.font_src
            // window.design_editor.active_page.updateTextAreaStyling(design_selection);
        }else if(type=='fontSize'){
            design_selection.text_details.fontSize = value.value
            // window.design_editor.active_page.updateTextAreaStyling(design_selection);
        }else if(type=='color'){
            design_selection.text_details.fontColor = value.hex
        }else if(type=='bold'){
            design_selection.text_details.bold = !design_selection.text_details.bold
            // window.design_editor.active_page.updateTextAreaStyling(design_selection);
        }else if(type=='italic'){
            design_selection.text_details.italic = !design_selection.text_details.italic
            // window.design_editor.active_page.updateTextAreaStyling(design_selection);
        }else if(type=='textAlign'){
            if(design_selection.text_details.textAlign == 'left'){
                design_selection.text_details.textAlign = 'center'
            }else if(design_selection.text_details.textAlign == 'center'){
                design_selection.text_details.textAlign = 'right'
            }else if(design_selection.text_details.textAlign == 'right'){
                design_selection.text_details.textAlign = 'left'
            }

            // window.design_editor.active_page.updateTextAreaStyling(design_selection);
        }else if(type=='letterSpacing'){
            design_selection.text_details.letterSpacing = Number(value)
            // window.design_editor.active_page.updateTextAreaStyling(design_selection);
        }else if(type=='lineHeight'){
            design_selection.text_details.lineHeight = Number(value)
            // window.design_editor.active_page.updateTextAreaStyling(design_selection);
        }else if(type == 'text_effects'){
            for(var key in value){
                if(design_selection.text_details.hasOwnProperty(key)){
                    design_selection.text_details[key] = value[key]
                }
            }
        }

        design_selection.set_redraw()

        this.set_state({design_selection:design_selection})
        .then(() => {
            var dont_add_undo = false
            if(type == 'opacity' || type == 'letterSpacing' || type == 'lineHeight' || type == 'color' || type == 'text_effects') {
                dont_add_undo = true
            }
            this.post_design_selection(dont_add_undo)
        })
    }

    update_inputs_background = (value,type) => {
        var design_editor = window.design_editor

        if(type == 'flip_horizontal'){
            design_editor.active_page.background.image_details.flip_horizontal *= -1
        }else if(type == 'flip_vertical'){
            design_editor.active_page.background.image_details.flip_vertical *= -1
        }else if(type == 'color'){
            // if(design_editor.active_page.background.image_exists()){
            //     design_editor.active_page.background.image_details.filter_color = value.hex;
            // }else{
                design_editor.active_page.background.background_color = value.hex
            // }
        }else if(type == 'filter'){
            design_editor.active_page.background.image_details.filter = {id:value}
        }else if(type == 'filter_adjustment'){
            for(var key in value){
                design_editor.active_page.background.filter[key] = value[key]
            }
        }else if(type == 'bgremoval'){
            design_editor.active_page.background.loader_image = window.design_editor.design.loaded_images[design_editor.active_page.background.image_cache_id()];
            design_editor.active_page.background.reset_bgremoval();
            for(var key in value){
                design_editor.active_page.background.bgremoval[key] = value[key]
            }
        }else if(type == 'mockup_details'){
            design_editor.active_page.background.loader_image = window.design_editor.design.loaded_images[design_editor.active_page.background.image_cache_id()];
            design_editor.active_page.background.reset_mockup_details();
            for(var key in value){
                design_editor.active_page.background.mockup_details[key] = value[key]
            }
        }

        design_editor.active_page.background.set_redraw()

        // design_editor.draw()
        var dont_add_undo = false
        // design_editor.addUndoChange()
        // this.set_state({})
        this.post_design_selection(dont_add_undo)
    }

    update_inputs_image = (value,type) => {
        if(!type){
            return
        }

        var design_selection = this.state.design_selection
        if(type == 'flip_horizontal'){
            design_selection.image_details.flip_horizontal *= -1
        }else if(type == 'flip_vertical'){
            design_selection.image_details.flip_vertical *= -1
        }else if(type == 'filter'){
            design_selection.image_details.filter = {id:value}
        }else if(type == 'filter_adjustment'){
            for(var key in value){
                design_selection.filter[key] = value[key]
            }
        }else if(type == 'bgremoval'){
            design_selection.loader_image = window.design_editor.design.loaded_images[design_selection.image_cache_id()];
            design_selection.reset_bgremoval();
            for(var key in value){
                design_selection.bgremoval[key] = value[key]
            }
        }else if(type == 'mockup_details'){
            design_selection.loader_image = window.design_editor.design.loaded_images[design_selection.image_cache_id()];
            design_selection.reset_mockup_details();
            for(var key in value){
                design_selection.mockup_details[key] = value[key]
            }
        }else if(type.indexOf('svg_color')>-1){
            var index = type.split('svg_color_')[1];
            design_selection.image_details.svg_colors[index].color = value.hex
            design_selection.updateColors()
        }

        design_selection.set_redraw()

        if(type == 'filter_adjustment'){
            var dont_add_undo = false
            if(type.indexOf('svg_color_')>-1 || type.indexOf('filter_adjustment')>-1) {
                dont_add_undo = true
            }
            this.post_design_selection(dont_add_undo)
        }else{
            this.set_state({design_selection:design_selection})
            .then(() => {
                var dont_add_undo = false
                if(type.indexOf('svg_color_')>-1 || type.indexOf('filter_adjustment')>-1) {
                    dont_add_undo = true
                }
                this.post_design_selection(dont_add_undo)
            })
        }

    }

    update_inputs_general = (value,type) => {
        var design_selection = this.state.design_selection
        if(design_selection && design_selection.get_parent('grid')){
            design_selection = design_selection.get_parent('grid')
        }

        if(design_selection && design_selection.getGroup()){
            design_selection = design_selection.getGroup()
        }

        var layer_buttons
        if(type == 'copy_and_paste'){
            var copy = design_selection.copy()
            if(copy.group && copy.objects){
                copy.group.position.x += 40;
                copy.group.position.y += 40;
                window.design_editor.addGroup(JSON.parse(JSON.stringify(copy)),undefined,true);
            }else{
                copy.position.x += 40;
                copy.position.y += 40;
                window.design_editor.addObject(JSON.parse(JSON.stringify(copy)),undefined,true);
            }
        }else if(type == 'delete'){
            design_selection.remove()
            this.set_state({toolbar_type:null})
            design_selection = null;
            window.design_editor.deselectElements()
        }else if(type == 'layer_up'){
            var objects_to_edit = []
            if(design_selection.type == 'group'){
                objects_to_edit = design_selection.group_details.object_data.map(o => o.object);
            }else{
                objects_to_edit = [design_selection]
            }

            window.design_editor.shiftLayerIndex(objects_to_edit,'up')

            layer_buttons = this.get_layer_buttons(objects_to_edit)
        }else if(type == 'layer_down'){
            var objects_to_edit = []
            if(design_selection.type == 'group'){
                objects_to_edit = design_selection.group_details.object_data.map(o => o.object);
            }else{
                objects_to_edit = [design_selection]
            }

            window.design_editor.shiftLayerIndex(objects_to_edit,'down')

            layer_buttons = this.get_layer_buttons(objects_to_edit)
        }else if(type == 'position_top'){
            window.design_editor.positionObject(design_selection,'position_top')
        }else if(type == 'position_middle'){
            window.design_editor.positionObject(design_selection,'position_middle')
        }else if(type == 'position_bottom'){
            window.design_editor.positionObject(design_selection,'position_bottom')
        }else if(type == 'position_left'){
            window.design_editor.positionObject(design_selection,'position_left')
        }else if(type == 'position_center'){
            window.design_editor.positionObject(design_selection,'position_center')
        }else if(type == 'position_right'){
            window.design_editor.positionObject(design_selection,'position_right')
        }else if(type == 'bring_front'){
            var objects_to_edit = []
            if(design_selection.type == 'group'){
                objects_to_edit = design_selection.group_details.object_data.map(o => o.object);
            }else{
                objects_to_edit = [design_selection]
            }

            window.design_editor.shiftLayerIndex(objects_to_edit,'top')

            layer_buttons = this.get_layer_buttons(objects_to_edit)
        }else if(type == 'send_back'){
            var objects_to_edit = []
            if(design_selection.type == 'group'){
                objects_to_edit = design_selection.group_details.object_data.map(o => o.object);
            }else{
                objects_to_edit = [design_selection]
            }

            window.design_editor.shiftLayerIndex(objects_to_edit,'bottom')

            layer_buttons = this.get_layer_buttons(objects_to_edit)
        }else if(type == 'send_back'){
            var objects_to_edit = []
            if(design_selection.type == 'group'){
                objects_to_edit = design_selection.group_details.object_data.map(o => o.object);
            }else{
                objects_to_edit = [design_selection]
            }

            window.design_editor.shiftLayerIndex(objects_to_edit,'bottom')

            layer_buttons = this.get_layer_buttons(objects_to_edit)
        }else if(type=='opacity'){
            function iterateAndChangeOpacity(sel){
                if(sel.type == 'group'){
                    for (var i = 0; i < sel.group_details.object_data.length; i++) {
                        iterateAndChangeOpacity(sel.group_details.object_data[i].object)
                    }
                }else{
                    sel.opacity = Number(value)/100
                }
                sel.set_redraw();
            }

            iterateAndChangeOpacity(design_selection)
        }else if(type=='lock'){
            if(design_selection.locked || (design_selection.getGroup() && (design_selection.getGroup().locked || (design_selection.getGroup().group_details.object_data.find(o => o.object.locked)) ))){
                design_selection.locked = false;
                if(design_selection.type == 'group'){
                    design_selection.locked = false;
                    for (var i = 0; i < design_selection.group_details.object_data.length; i++) {
                        design_selection.group_details.object_data[i].object.locked = false;
                    }
                }
            }else{
                design_selection.locked = true;
                if(design_selection.type == 'group'){
                    design_selection.locked = true;
                    for (var i = 0; i < design_selection.group_details.object_data.length; i++) {
                        design_selection.group_details.object_data[i].object.locked = true;
                    }
                }
            }
        }else if(type=='group'){
            window.design_editor.groupTemporaryGroup();
        }else if(type=='ungroup'){
            design_selection.ungroup()
            this.set_state({toolbar_type:null})
            design_selection = null;
            window.design_editor.deselectElements()
        }

        if(design_selection){
            design_selection = this.state.design_selection
        }

        var updates = {}
        if(type !== 'copy_and_paste'){
            updates.design_selection = design_selection
        }
        if(layer_buttons){
            updates['layer_buttons'] = layer_buttons
        }
        this.set_state(updates)
        .then(() => {
            this.post_design_selection()
        })
    }

    update_inputs_grid = (value,type) => {
        if(!type){
            return
        }
        var design_selection = this.state.design_selection

        var box = design_selection.get_parent('box');
        var grid = design_selection.get_parent('grid');

        if(type == 'flip_horizontal'){
            box.image.image_details.flip_horizontal *= -1
        }else if(type == 'flip_vertical'){
            box.image.image_details.flip_vertical *= -1
        }else if(type == 'filter'){
            if(box && box.image){
                box.image.image_details.filter = {id:value}
            }
        }else if(type == 'filter_adjustment'){
            if(box && box.image){
                for(var key in value){
                    box.image.filter[key] = value[key]
                }
            }
        }else if(type == 'bgremoval'){
            if(box && box.image){
                box.image.loader_image = window.design_editor.design.loaded_images[box.image.image_cache_id()];
                box.image.reset_bgremoval();
                for(var key in value){
                    box.image.bgremoval[key] = value[key]
                }
            }
        }else if(type == 'mockup_details'){
            if(box && box.image && box.image.sub_type == 'mockup'){
                box.image.loader_image = window.design_editor.design.loaded_images[box.image.image_cache_id()];
                box.image.reset_mockup_details();
                for(var key in value){
                    box.image.mockup_details[key] = value[key]
                }
            }
        }else if(type.indexOf('color')>-1){
            box.color = value.hex
        }

        if(grid){
            grid.set_redraw()
        }

        this.set_state({design_selection:design_selection})
        .then(() => {
            var dont_add_undo = false
            if(type.indexOf('color')>-1) {
                dont_add_undo = true
            }
            this.post_design_selection(dont_add_undo)
        })
    }


    fetch_user_uploads = () =>
        fetch_user_uploads(this.props.user.my_photos_folder)
        .then(uploads => {
            var uploads = [...uploads.data[0].folder.resources.map(x => ({ src: x.path, low_src: x.low_path }) )];
            return this.set_state({uploads})
        })
        .catch(err => {
            console.log(err);
            toastr.error('something went wrong')
        })

    fetch_saved_mockups = async () => {
        try {
            var data = await feline_fetch({ url: 'mockup/get_all_saved', body: {} })
            await this.set_state({saved_mockups:data});
        } catch(err) {
            console.log(err)
        }
    }

    fetchBkFonts = async () => {
    	try{
            if(this.props.user){
				var resp = await feline_fetch({ url: 'user/get_brand_kit', method: 'GET' });
                if (!resp) {
                    console.error("Empty response from server");
                    return;
                }
				var brand_kit = JSON.parse(resp).data;
				if (brand_kit && brand_kit.length) {
					var colors = brand_kit.filter( x => x.name == 'colors' )[0].data.map( x => ({ name: x.name, colors: x.value.data }) );
					var fonts = brand_kit.filter( x => x.name == 'fonts' )[0].data.map( x => ({ name: x.name, fonts: x.value.data }) );
					fonts.map( x => {
						x.fonts.map(f => {
							var font_json = {name:f.name}
							if(f.file&&f.file[0]){
								font_json.url = encodeURI(f.file[0])
							}else{
								font_json.src = "uploads/design_resources/font/e166357211e5a69fa42cfad738627789.ttf";
							}
							load_font(font_json);
						});
					});


					this.setState({brandkit_font_sets: fonts, brandkit_color_palettes: colors});
				}
					
            }else{
                return Promise.resolve(null)
            }
        }catch(error) {
            return Promise.reject(error);
        }
    }


    componentDidUpdate(prev_props, prev_state) {
        if (this.state.design_selection != prev_state.design_selection) {
            if(this.state.active_nav_tab == 'filters' || this.state.active_nav_tab == 'fonts' || this.state.active_nav_tab == 'text_effects' || this.state.active_nav_tab == 'adjust' || this.state.active_nav_tab == 'remove_background' || this.state.active_nav_tab == 'mockup_editor' || this.state.active_nav_tab == 'animations' || this.state.active_nav_tab == 'shadows'){
                this.setState({
                    active_nav_tab: this.state.previous_nav_tab,
                    previous_nav_tab: this.state.previous_nav_tab
                })
            }

            this.setState({grid_bulk_edit_label_temp:''})
        }


        if (this.props.user != prev_props.user) {
            this.fetch_user_uploads();
        }

        if(this.state.redirect != prev_state.redirect){
            this.setState({redirect:false,redirect_url:null})
        }

        if(prev_state.collapse_sidebar != this.state.collapse_sidebar && window.design_editor){
            window.design_editor.handleWindowResize();
        }
    }


    componentDidMount() {

        this.update_window_size();
        window.onresize = this.update_window_size;

        if ((this.is_admin_designs() || this.is_admin_text_templates()) && (!this.props.user || (this.props.user && this.props.user.type !== 'admin' && this.props.user.type !== 'designer'))) {
            toastr.error('Unauthorized');
            this.redirect_page('/designmaker/start');
        }

        let is_admin = true;
        let design_promise;

        if (this.is_admin_designs()) {
            design_promise = this.props.fetch_design_template(this.props.match.params.design_id)
        } else if (this.is_admin_text_templates()) {
            design_promise = this.props.fetch_text_template(this.props.match.params.template_id)
                .then(text_template => {
                    let base_design = {"id":"1ec683b5-fb43-429f-bb0e-a13ef617a2b1","width":800,"height":800,"pages":[{"id":"17575320936194003893","objects":[],"groups":[],"background_color":"#ffffff","background_image":null,"background_labels":{"text_type":"","colors":[],"brand_logo":""}}]}
                    base_design.pages[0].groups = [text_template.data.design_file.group];
                    base_design.pages[0].objects = text_template.data.design_file.objects;
                    return {response_code: 1,data: {design_file:base_design}}
                })
        }
        else {
            is_admin = false;
            design_promise = this.props.fetch_saved_design(this.props.match.params.design_id)
        }

        localStorage.setItem("active_design", this.props.match.params.design_id);

        //functions to expose to global scope
        window.set_design_variables = this.set_design_variables;
        window.rct_update_pages = this.rct_update_pages;
        window.rct_set_crop_mode = this.rct_set_crop_mode
        window.rct_set_zoom = this.set_zoom;
        window.switch_nav_tab = this.switch_nav_tab
        window.update_inputs_general = this.update_inputs_general

        if(!this.props.user){
            this.setState({photos_subscription:false})
        }else if(this.props.user.type === 'admin' || (/*this.props.user['inmagineUser']['userDetails']['user']['subscription']['scope'].includes("designmaker") && */this.props.user['inmagineUser']['userDetails']['user']['subscription']['sub_status'] === true && this.props.user['inmagineUser']['userDetails']['user']['subscription']['sub_free_plan'] !== true)) {
            this.setState({photos_subscription:true})
        }

        Promise
            .all([design_promise])
            .then(data => {
                data = data[0];
                let design_file = {"pages":[{"background_color":"rgba(255,255,255,1)","objects":[]}]};
                if (data.response_code === 1 && data.data && data.data.design_file) {
                    design_file = data.data.design_file;
                    let link_sharing_enabled = data.data.view_all || data.data.edit_all
                    this.setState({ design:data.data, designName: data.data.name, link_sharing_enabled, enable_share_switch_for_edit: data.data.edit_all, enable_share_switch_for_view: data.data.view_all })
                }else{
                    // this.redirect_page('/designmaker/start')
                }
                let design_save_id = (!is_admin&&data.response_code === 1?data.data._id:null);
                this.set_state({pages: design_file.pages.length,design_save_id:design_save_id})
                    .then(() => {
                        if (data.data.role === 'view' && this.props.match.params.role !== data.data.role) {
                            //This is causing an issue
                            // this.redirect_page('/designmaker/start/designs/'+this.props.match.params.design_id+'/'+data.data.role);
                            this.redirect_page('/designmaker/start/');
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                        toastr.error("Something went wrong");
                    })
            })
            .catch(e => {
                console.error(e);
                this.redirect_page('/designmaker/start');
            });

        this.fetch_more_text_templates();

        if (this.props.user) {
            this.fetch_user_uploads();
            this.fetch_saved_mockups();
            this.fetchBkFonts();
        }

        for (var key in default_dimensions) {
            this.resize_options.push(
                <FormGroup key={key}>
                    <Col sm={12}>
                      <Checkbox id={key} onChange={e => this.update_resize_options(e)}>{key + ' '+ '('+ default_dimensions[key].width + 'x' + default_dimensions[key].height +' px)'}</Checkbox>
                    </Col>
                </FormGroup>
            )
        }
    }

    componentWillUnmount() {
        if(window.design_editor){
            window.design_editor.destroy();
        }

        delete window.design_editor
    }

    get_layer_buttons = (objects_to_edit) => {
        var layer_buttons = {top:false,bottom:false}

        if(window.design_editor && window.design_editor.active_page){
            layer_buttons = {top: window.design_editor.areObjectsAtTop(objects_to_edit),bottom: window.design_editor.areObjectsAtBottom(objects_to_edit)}
        }

        return layer_buttons
    }

    set_design_variables = (toolbar_type,design_selection,label_rules,crop_mode,deselection) => {
        var needs_update = false
        if(this.state.toolbar_type != toolbar_type){
            needs_update = true
        }

        if((this.state.label_rules == null && label_rules!=null) || (this.state.label_rules != null && label_rules==null)){
            needs_update = true
        }

        if((this.state.design_selection == null && design_selection!=null) || (this.state.design_selection != null && design_selection==null)){
            needs_update = true
        }

        if(this.state.label_rules!=null && label_rules != null){
            for(var key in label_rules){
                if(this.state.label_rules[key] != label_rules[key]){
                    needs_update = true;
                    break;
                }
            }
        }

        if(design_selection != this.state.design_selection){
            needs_update = true;
        }

        if(crop_mode != this.state.crop_mode){
            needs_update = true;
        }

        var layer_buttons = {top:false,bottom:false}

        if(window.design_editor  && window.design_editor.active_page && design_selection && design_selection.constructor.name != 'String'){
            var d
            if(design_selection && design_selection.getGroup()){
                d = design_selection.getGroup()
            }else if(design_selection && design_selection.get_parent('grid')){
                d = design_selection.get_parent('grid')
            }else{
                d = design_selection
            }

            var objects_to_edit = []
            if(d.type == 'group'){
                objects_to_edit = d.group_details.object_data.map(o => o.object);
            }else{
                objects_to_edit = [d]
            }

            layer_buttons = {top: window.design_editor.areObjectsAtTop(objects_to_edit),bottom: window.design_editor.areObjectsAtBottom(objects_to_edit)}
        }

        if(needs_update){
            var updates = {
                toolbar_type: toolbar_type,
                design_selection: design_selection,
                label_rules: label_rules,
                layer_buttons: layer_buttons,
                crop_mode: crop_mode
            }

            if(deselection && (this.state.active_nav_tab == 'filters' || this.state.active_nav_tab == 'text_effects' || this.state.active_nav_tab == 'adjust' || this.state.active_nav_tab == 'fonts' || this.state.active_nav_tab == 'remove_background' || this.state.active_nav_tab == 'mockup_editor' || this.state.active_nav_tab == 'animations' || this.state.active_nav_tab == 'shadows')){
                updates['active_nav_tab'] = 'templates'
            }
            this.setState(updates)
        }
    }

    purchases_on_click = (resource) => {
        if(resource.id_imagemaker){
            window.design_editor.addObject({
                type: 'image',
                image_details:{
                    id_imagemaker: resource.id_imagemaker
                }
            })
        }else if(resource.id_123rf){
            window.design_editor.addObject({
                type: 'image',
                image_details:{
                    id_123rf: resource.id_123rf
                }
            })
        }else if(resource.id_123rf_plus){
            window.design_editor.addObject({
                type: 'image',
                image_details:{
                    id_123rf_plus: resource.id_123rf_plus
                }
            })
        }else if(resource.id_pixlr){
            window.design_editor.addObject({
                type: 'image',
                image_details:{
                    id_pixlr: resource.id_pixlr
                }
            })
        }else if(resource.id_unsplash){
            window.design_editor.addObject({
                type: 'image',
                image_details:{
                    id_unsplash: resource.id_unsplash
                }
            })
        }else if(resource.id_design_resource){
            window.design_editor.addObject({
                type: 'image',
                image_details:{
                    resource_id: resource.id_design_resource
                }
            })
        }else if(resource.path){
            window.design_editor.addObject({
                type: 'image',
                image_details:{
                    src: resource.path
                }
            })
        }
    }


    fetch_more_text_templates = () => {
        var payload = {
            page_no: this.state.design_resources_text_templates.page_no,
            size: 20,
            priority_sort: true
        };
        fetch(global.config.server_path+'text_template/get/', {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify(payload)}).then(resp => resp.json()).then(resp => resp.data)
        .then(data => {
            this.setState({
                design_resources_text_templates: {
                    data : this.state.design_resources_text_templates.data.concat(data.docs),
                    page_no : this.state.design_resources_text_templates.page_no += 1
                }
            })
        })
            .catch(error => console.log(error))
    }

    // export_design = (download_option) => {
    //     if(!download_option){
    //         download_option = 'png';
    //     }
    //     function executeDownload(this_as_param){
    //         if(download_option == 'png' || download_option == 'jpg'){
    //             if(window.design_editor.design.pages.length>1 || Object.keys(this_as_param.state.resize_dimensions).length>0){
    //                 var zip = new JSZip();
    //                 var old_data = window.design_editor.save();

    //                 for(var i = 0; i < window.design_editor.design.pages.length; i++) {
    //                     if(download_option == 'png'){
    //                         zip.file("page "+ Number(i+1)+".png", window.design_editor.design.pages[i].export('high').replace(/^data:image\/(png|jpeg);base64,/, ""), {base64: true});
    //                     }else{
    //                         zip.file("page "+ Number(i+1)+".jpg", window.design_editor.design.pages[i].export('high_jpg').replace(/^data:image\/(png|jpeg);base64,/, ""), {base64: true});
    //                     }

    //                     for(var key in this_as_param.state.resize_dimensions){
    //                         var t0 = performance.now();
    //                         window.design_editor.magicResize(default_dimensions[key].width,default_dimensions[key].height,'px')
    //                         if(download_option == 'png'){
    //                             zip.file("page "+ Number(i+1)+" "+key+".png", window.design_editor.design.pages[i].export('high').replace(/^data:image\/(png|jpeg);base64,/, ""), {base64: true});
    //                         }else{
    //                             zip.file("page "+ Number(i+1)+" "+key+".jpg", window.design_editor.design.pages[i].export('high_jpg').replace(/^data:image\/(png|jpeg);base64,/, ""), {base64: true});
    //                         }
    //                         window.design_editor.load(old_data)
    //                     }
    //                 }
    //                 zip.generateAsync({type:"blob"})
    //                 .then(function(content) {
    //                     // see FileSaver.js
    //                     window.saveAs(content, this_as_param.state.designName+".zip");
    //                     this_as_param.setState({
    //                         full_page_loader: false
    //                     })
    //                 });
    //             }else{
    //                 var download = window.document.createElement('a');
    //                 if(download_option == 'png'){
    //                     download.href = window.design_editor.design.pages[0].export('high');
    //                     download.download = this_as_param.state.designName + '.png';
    //                 }else{
    //                     download.href = window.design_editor.design.pages[0].export('high_jpg');
    //                     download.download = this_as_param.state.designName + '.jpg';
    //                 }
    //                 download.click();
    //                 this_as_param.setState({
    //                     full_page_loader : false
    //                 })
    //             }
    //         }else if(download_option == 'pdf'){
    //             window.design_editor.print(this_as_param.state.designName);
    //             this_as_param.setState({
    //                 full_page_loader : false
    //             })
    //         }
    //     }

    //     this.setState({
    //         full_page_loader : true,
    //         full_page_loader_message : "Downloading your design..."
    //     })
    //     Promise.all(window.design_editor.resource_promise_array)
    //     .then(() => {
    //         executeDownload(this)
    //     }).catch(err => {
    //         executeDownload(this)
    //     })
            
    // }

    export_design = async (download_option) => {
        this.setState({
            full_page_loader : true,
            full_page_loader_message : "Downloading your design..."
        })

        try{
            // console.log(' generating export data --> ', window.design_editor.design);
            await window.download_design(download_option, this.state.designName, window.design_editor.design);
        }catch(err){
            console.log(err);
            toastr.error('something went wrong')
        }

        this.setState({
            full_page_loader : false
        })
    }

    back_onclick = () =>{
        if(window.design_editor){
            this.setState({full_page_loader:true,full_page_loader_message:"Saving your work, it should take only a few seconds ..."});
            window.design_editor.save_backend(true).then(() => {
                this.setState({full_page_loader:false});
                this.redirect_page('/designmaker/start')
            })
        }else{
            this.setState({full_page_loader:false});
            this.redirect_page('/designmaker/start') 
        }
    }

    upload_file = file => {
        if (this.props.user) {
            upload_user_file(file, this.props.user.my_photos_folder)
            .then(() => this.fetch_user_uploads())
            .then(() => toastr.success('file upload success'))
        } else {
            window.fetchFileSrcWithFile(file)
            .then(src => {
                var uploads = this.state.uploads;
                uploads.push({src});
                this.set_state({uploads})
            })
        }
    } 

    create_order = () => {
        var design_id = this.props.match.params.design_id;
        var resources = this.state.premium_resources;
        var coupon_code = null;
        if (this.state.coupon_applied) {
            coupon_code = this.state.coupon_code;
        }

        return create_order(design_id, resources, coupon_code)
        .then(data => {
            if (data.response_code == 1) {
                return this.set_state({order_id: data.data._id})
                .then(() => {
                    return Promise.resolve();
                })
            } else {
                return Promise.reject()
            }
        })
    }


    order_complete = order => {
        // this.redirect_page('/designmaker/start/orders')
        if(order.response_code == 1){
            var id_array = order.data.skus.map(function(o){
                if(o.type == 'design_resource'){
                    return o.design_resource
                }else if(o.type == '123rf_image'){
                    return o.rf_image
                }else if(o.type == '123rf_plus_image'){
                    return o.rf_plus_image
                }else if(o.type == 'pixlr_image'){
                    return o.pixlr_image
                }
            })
            window.design_editor.handlePurchaseRedraw(id_array);
            this.payment_modal_close()
        }

    }

    save_design_template_admin = () => {
        window.design_editor.save_design_template_admin(this.props.match.params.design_id)
        .then(resp => {
            toastr.success('Saved successfully!');
        })
    }

    save_text_template_admin = () => {
        window.design_editor.save_text_template_admin(this.props.match.params.template_id)
        .then(resp => {
            toastr.success('Saved successfully!');
        })
    }

    is_admin_designs = () => {
        return window.location.href.indexOf('admin_designs')>-1
    }

    is_admin_text_templates = () => {
        return window.location.href.indexOf('admin_text_templates')>-1
    }

    design_undo = () => {
        window.design_editor.undo()
    }

    design_redo = () => {
        window.design_editor.redo()
    }

    hardcoded_text_fields = [
        {design_file: {"type":"text","sub_type":"","layer_index":0,"labels":{"text":"","image":"","colors":[]},"text_details":{"text":"Add a heading","font_src":"uploads/design_resources/font/e166357211e5a69fa42cfad738627789.ttf","bold":false,"italic":false,"font":"Montserrat","fontSize":72,"fontColor":"#000000","shadowColor":"#ffff00","shadowType":"none","textAlign":"center","rotation":0,"stroke":false,"strokeWidth":"1px","strokeColor":"#0000ff","letterSpacing":0,"lineHeight":0},"image_details":{"src":"","id_imagemaker":"","id_123rf":"","id_unsplash":"","resource_id":"","flip_horizontal":1,"flip_vertical":1,"image_width":738.4430964197892,"image_height":738.4430964197892,"svg_colors":[],"contentDisplacement":{"x":-206.38681936351202,"y":-219.2215482098946},"filter":null,"image_needs_autoset":false},"filter":{"brightness":0,"contrast":0,"saturation":0,"tint":0,"blur":0,"vignette":0},"grid_details":{"boxes":[]},"group_details":{"object_data":[]},"position":{"x":114.30499188311688,"y":127.5235512299951},"opacity":1,"width":538.0562770562772,"height":86.39999999999999,"rotation":0,"locked":false}},
        {design_file: {"type":"text","sub_type":"","layer_index":1,"labels":{"text":"","image":"","colors":[]},"text_details":{"text":"Add a subheading","font_src":"uploads/design_resources/font/e166357211e5a69fa42cfad738627789.ttf","bold":false,"italic":false,"font":"Montserrat","fontSize":36,"fontColor":"#000000","shadowColor":"#ffff00","shadowType":"none","textAlign":"center","rotation":0,"stroke":false,"strokeWidth":"1px","strokeColor":"#0000ff","letterSpacing":0,"lineHeight":0},"image_details":{"src":"","id_imagemaker":"","id_123rf":"","id_unsplash":"","resource_id":"","flip_horizontal":1,"flip_vertical":1,"image_width":363.57142857142856,"image_height":363.57142857142856,"svg_colors":[],"contentDisplacement":{"x":-27.117942176870656,"y":-31.785714285714278},"filter":null,"image_needs_autoset":false},"filter":{"brightness":0,"contrast":0,"saturation":0,"tint":0,"blur":0,"vignette":0},"grid_details":{"boxes":[]},"group_details":{"object_data":[]},"position":{"x":154.24719387755104,"y":320.77414965986384},"opacity":1,"width":338.4534863945579,"height":43.199999999999996,"rotation":0,"locked":false}},
        {design_file: {"type":"text","sub_type":"","layer_index":0,"labels":{"text":"","image":"","colors":[]},"text_details":{"text":"Add a little bit of body text","font_src":"uploads/design_resources/font/e166357211e5a69fa42cfad738627789.ttf","bold":false,"italic":false,"font":"Montserrat","fontSize":24,"fontColor":"#000000","shadowColor":"#ffff00","shadowType":"none","textAlign":"center","rotation":0,"stroke":false,"strokeWidth":"1px","strokeColor":"#0000ff","letterSpacing":0,"lineHeight":0},"image_details":{"src":"","id_imagemaker":"","id_123rf":"","id_unsplash":"","resource_id":"","flip_horizontal":1,"flip_vertical":1,"image_width":395.7149676099556,"image_height":395.7149676099556,"svg_colors":[],"contentDisplacement":{"x":-70.00229591836728,"y":-47.85748380497779},"filter":null,"image_needs_autoset":false},"filter":{"brightness":0,"contrast":0,"saturation":0,"tint":0,"blur":0,"vignette":0},"grid_details":{"boxes":[]},"group_details":{"object_data":[]},"position":{"x":230.95556492092302,"y":394},"opacity":1,"width":327.7126716915883,"height":28.799999999999997,"rotation":0,"locked":false}}
    ]

    update_inputs = (event) => {
        this.setState({[event.target.name]: event.target.value})
    };

    /*

    apply_coupon = () => {
        if (this.state.coupon_code) {
            this.props.calculate_price(this.get_order_total(), this.state.coupon_code)
            .then(resp => {
                if (resp.response_code == 1) {
                    var discount = this.get_order_total() - resp.data.price;
                    this.setState({discount, coupon_applied: true});
                    toastr.success('Coupon Applied')
                } else {
                    toastr.error('Invalid Coupon or Voucher');
                }
            })
        } else {
            toastr.error('Please enter coupon code')
        }
    }


    remove_coupon = () => {
        this.setState({coupon_applied: false, coupon_code: null, discount: 0})
    }
     */



    toggle_overlay = () => {
        if (window.document.getElementById('popover_overlay_share').style.display == "none") {
            window.document.getElementById('popover_overlay_share').style.display = "block"
        } else {
            window.document.getElementById('popover_overlay_share').style.display = "none"
        }
    }

    toggle_overlay_zoom = () => {
        if (window.document.getElementById('popover_overlay_zoom').style.display == "none") {
            window.document.getElementById('popover_overlay_zoom').style.display = "block"
        } else {
            window.document.getElementById('popover_overlay_zoom').style.display = "none"
        }
    }

    apply_filters = async (value) => {

        await this.set_state({filterIntensity : 50});

        if(this.state.design_selection){
            if(this.state.design_selection.get_parent('grid')){
                this.update_inputs_grid(value,'filter')
            }else if(this.state.design_selection.type === 'image'){
                this.update_inputs_image(value,'filter')
            }
        }else if(this.state.toolbar_type=='background'){
            this.update_inputs_background(value,'filter')
        }
    };

    apply_filter_adjustments = (value) => {
        if(this.state.design_selection){
            if(this.state.design_selection.get_parent('grid')){
                this.update_inputs_grid(value,'filter_adjustment')
            }else if(this.state.design_selection.type === 'image'){
                this.update_inputs_image(value,'filter_adjustment')
            }
        }else if(this.state.toolbar_type=='background'){
            this.update_inputs_background(value,'filter_adjustment')
        }
    }

    apply_text_effects = (value) => {
        if(this.state.design_selection && this.state.design_selection.type == 'text'){
            this.update_inputs_text(value,'text_effects')
        }
    }

    apply_background_removal = (value) => {
        if(this.state.design_selection){
            if(this.state.design_selection.get_parent('grid')){
                this.update_inputs_grid(value,'bgremoval')
            }else if(this.state.design_selection.type === 'image'){
                this.update_inputs_image(value,'bgremoval')
            }
        }else if(this.state.toolbar_type=='background'){
            this.update_inputs_background(value,'bgremoval')
        }
    }

    toggle_background_removal = () => {
        var value = {crf: 0,matting: 0, enabled: true }
        if(this.state.design_selection){
            if(this.state.design_selection.get_parent('grid')){
                var box = this.state.design_selection.get_parent('box')
                if(box && box.image){
                    value.enabled = !box.image.bgremoval.enabled
                }else{
                    return
                }
            }else if(this.state.design_selection.type === 'image'){
                value.enabled = !this.state.design_selection.bgremoval.enabled
            }
        }else if(this.state.toolbar_type=='background'){
            value.enabled = !window.design_editor.active_page.background.bgremoval.enabled;
        }

        this.apply_background_removal(value);
    }

    apply_mockup_editor = (mockup_details) => {
        if(this.state.design_selection){
            if(this.state.design_selection.get_parent('grid')){
                this.update_inputs_grid(mockup_details,'mockup_details')
            }else if(this.state.design_selection.type === 'image'){
                this.update_inputs_image(mockup_details,'mockup_details')
            }
        }else if(this.state.toolbar_type=='background'){
            this.update_inputs_background(mockup_details,'mockup_details')
        }
    }

    generateFilterCard = (index, filterName, displayName, src, isActive) => {
        return (<Col
            key={'filter_key'+index}
            style={{padding:'0',marginBottom:'5px'}}
            xs={4}
        >
            <div
                style={{cursor : 'pointer'}}
                onClick={(e) => {this.apply_filters(filterName)}}
            >
                <Image
                    className={isActive?'glowing-border':'filter-div'}
                    height="80px"
                    src={global.config.static_file_server_path+src}
                />
                <p style={{fontSize : '1.2rem',fontWeight : 400, marginTop : 2, color:'black'}} >{displayName}</p>
            </div>
        </Col>)
    };

    filterIntensityOnChange = (e) => {
        this.setState({
            filterIntensity : e.target.value
        })
    };

    FiltersPanel = () => {

        let active_filter = null;

        if(this.state.design_selection.get_parent('grid')){
            if(this.state.design_selection.get_parent('box') && this.state.design_selection.get_parent('box').image && this.state.design_selection.get_parent('box').image.image_details.filter){
                active_filter=this.state.design_selection.get_parent('box').image.image_details.filter.id
            }else if(this.state.design_selection.get_parent('box') && this.state.design_selection.get_parent('box').frame && this.state.design_selection.get_parent('box').frame.image_details.filter){
                active_filter=this.state.design_selection.get_parent('box').frame.image_details.filter.id
            }
        }else if(this.state.design_selection.type === 'image'){
            if(this.state.design_selection.image_details.filter){
                active_filter=this.state.design_selection.image_details.filter.id
            }
        }
    

        let filters = [];

        for (let i=0; i<designFilters.length;i++) {
            filters.push(this.generateFilterCard(i, designFilters[i].filterName, designFilters[i].displayName, designFilters[i].src, active_filter===designFilters[i].filterName));
            // if (i%3 === 2) {
            //     let displaySlider = ((active_filter !== designFilters[0].filterName) && (active_filter === designFilters[i].filterName || active_filter === designFilters[i-1].filterName || active_filter === designFilters[i-2].filterName));
            //     filters.push(<Col xs={12}><input key={"filter-slider-"+i} className={!displaySlider?"hide-filter-slider":"adjustment-slider"} type="range" min="1" max="100" value={this.state.filterIntensity} onChange={this.filterIntensityOnChange}/></Col>)
            // }
        }
        return filters;
    };

    send_invites = () => {
        var emails = this.state.share_emails
        if(this.state.last_email){
            emails.push(this.state.last_email)
        }
        if(this.state.design && emails.length>0 && this.state.share_role){
            this.props.share_permission_with_emails(this.props.user.email,emails,this.state.design._id,this.state.share_role)
            .then(resp => {
                toastr.success('design shared successfully!')
            })
            window.document.getElementById('overlay_button_share').click()
        }
    }

    rct_set_crop_mode = () => {
        this.set_state({crop_mode: true})
    }

    enter_crop_mode = () => {
        window.design_editor.setCropMode();
        if(window.design_editor.mode == "crop"){
            this.set_state({crop_mode: true})
            var cr = window.design_editor.getCropObject()
            if(cr){
                window.design_editor.initialCropObject = cr.save();    
            }
        }
    }

    crop_mode_done = () => {
        window.design_editor.deselectElements();
    }

    crop_mode_cancel = () => {
        if(window.design_editor.initialCropObject){
            if(window.design_editor.selection.object.get_parent('grid')){
                window.design_editor.selection.object.get_parent('grid').load(window.design_editor.initialCropObject)
            }else{
                window.design_editor.selection.object.load(window.design_editor.initialCropObject)
            }
        }

        window.design_editor.deselectElements();
    }

    set_zoom = (value) => {
        window.design_editor.design.page_zoom = value
        window.design_editor.handleWindowResize()
        window.document.getElementById('overlay_button_zoom').click()
        this.set_state({page_zoom_display: (value.constructor.name == 'Number'?value + '%':capFirst(value))})
    }

    close_sidebar = () => {
        this.set_state({collapse_sidebar : true, active_nav_tab: null})
        .then(() => {
            if(window.design_editor){
                window.design_editor.handleWindowResize();
            }
        })
    }

    enterMagicResize = () => {
        window.design_editor.deselectElements()
        this.setState({
            'show_magic_resize_modal': true
        })
    }

    enterSuggestMode = () => {
        this.setState({'show_suggest_design_modal': true})
    }

    open_sidebar = () => {
        this.set_state({collapse_sidebar: false})
        .then(() => {
            if(window.design_editor){
                window.design_editor.handleWindowResize();
            }
        })
    }

    switch_nav_tab = active_nav_tab => {
        if(this.state.previous_nav_tab == active_nav_tab){
            return this.set_state({active_nav_tab, collapse_sidebar: false, search_active: false, search_text: ''})
        }else{
            var prev = this.state.active_nav_tab
            if(prev == 'filters'||prev == 'fonts'||prev == 'text_effects'||prev == 'adjust'||prev == 'remove_background'||prev == 'mockup_editor' || prev == 'animations' || prev == 'shadows'){
                prev = this.state.previous_nav_tab
            }
            return this.set_state({active_nav_tab, collapse_sidebar: false,previous_nav_tab:prev, search_active: false, search_text: ''})
        }

    }

    fetch_search_results = (e) => {

        if (e) {e.preventDefault();}

        if (this.state.search_text == "") {
            this.setState({
                search_active : false
            });
            return;
        }
        this.setState({
            search_active : true,
            search_results: [],
            search_results_display: []
        });

        let nav_tab = this.state.active_nav_tab;

        if (nav_tab == 'elements') {

            var url = global.config.server_path+'design_resources/_search?'
            var type = 'image';
            var sub_type = nav_tab == 'elements' ? 'icon' : 'background';

            var query_body = {
                "from" : 0,
                "size" : 100,
                "query": {
                    "bool": {
                        "must": [{
                            "multi_match" : {
                                "query" : this.state.search_text,
                                "fields" : [ "name", "keywords"],
                                "operator" : "or",
                                "type" : "best_fields",
                                }
                            }],
                        "filter": [
                            {"term" : {"type" : type}},
                            {"term" : {"sub_type" : sub_type}}
                        ]
                    }
                }
            }

            return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify(query_body)})
            .then(resp => resp.json())
            .then(resp => Promise.resolve(resp.hits.hits.map(x => x._id)))
            .then(resp => {
                var url = global.config.server_path+'design_resource/get/';
                var payload = {
                    id : resp,
                    'type': type,
                    'sub_type' : sub_type
                };
                return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify(payload)})
            })
            .then(resp => resp.json())
            .then(data => {
                data = data.data.docs
                if (data) {
                    this.setState({
                        search_results : data,
                        search_results_display : data.slice(0, 20)
                    })
                }
                else {
                    toastr.warning('No results found.')
                }
            }).catch(err => Promise.reject(err))
        }

            if (nav_tab == 'text') {

            let url = global.config.server_path+'text_templates/_search?'

            let query_body = {
                "from": 0,
                "size": 100,
                "query": {
                    "bool": {
                        "must": {
                            "multi_match": {
                                "query": this.state.search_text,
                                "fields": ["categories.name", "keywords", "name"],
                                "operator": "or",
                                "type": "best_fields"
                            }
                        },
                        "filter": []
                    }
                }
            };

            return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify(query_body)})
            .then(resp => resp.json())
            .then(resp => Promise.resolve(resp.hits.hits.map(x => x._id)))
            .then(resp => {
                let url = global.config.server_path+'text_template/get/';
                return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({id : resp})})
            })
            .then(resp => resp.json())
            .then(data => {
                let results = data.data.docs;
                if (results) {
                    this.setState({
                        search_results : results,
                        search_results_display : results.slice(0, 20)
                    })
                }
                else {
                    toastr.warning('No results found.')
                }
            }).catch(err => Promise.reject(err))            
        }

    }

    fetch_next_search_results = () => {
        const display_len = this.state.search_results_display.length;
        const total_len = this.state.search_results.length;

        if (display_len == total_len && this.state.active_nav_tab == 'photos') {
            this.return_more_photos_123rf(this.state.search_text.split(' '), (total_len/100) + 1)
            .then(data => {
                if (data) {
                    this.setState({
                        search_results : this.state.search_results.concat(data),
                        search_results_display :this.state.search_results_display.concat(data.slice(0, 20))
                    })
                }
                else {
                    toastr.warning('No results found.')
                }
            })
            .catch(err => Promise.reject(err))
        }
        else {
            const new_results = this.state.search_results.slice(display_len, display_len + Math.min(20, total_len - display_len));
            this.setState({
                search_results_display : this.state.search_results_display.concat(new_results)
            })
        }
    }

    

    _rhs_options_panel = (col_width) => {
        if(!col_width){
            col_width = 6
        }

        const dropdown_heading_style = {
            fontSize: 14,
            fontWeight: 600,
            padding: 9
        }

        const Position_Dropdown_trigger = ({ toggle_dropdown }) => (
            <Button className="btn-toolbar" onClick={() => toggle_dropdown()} style={{ 'marginRight': '5px', outline: 'none', cursor: 'pointer' }}>
                <Image style={{ height: 20 }} src={global.config.static_file_server_path + 'uploads/icons/object_position.svg'} />
            </Button>
        )

        const Position_Dropdown_dropper = () => (
            <div className="dropdown-container" style={{ textAlign: 'left' }}>
                <span style={dropdown_heading_style} > Layer </span>
                <ul className="toolbar-dropdown two-column-dropdown">
                    <li className="toolbar-dropdown-item" onClick={(e) => {if(!this.state.layer_buttons.top){(this.update_inputs_general(e,'layer_up'))}}}>
                        <Image style={{ height: 8 }} src={global.config.static_file_server_path + 'uploads/icons/forward.svg'} />
                        <span className="toolbar-dropdown-text">Forward</span>
                    </li>
                    <li className="toolbar-dropdown-item" onClick={(e) => {if(!this.state.layer_buttons.top){(this.update_inputs_general(e,'bring_front'))}}}>
                        <Image style={{ height: 12 }} src={global.config.static_file_server_path + 'uploads/icons/to_front.svg'} />
                        <span className="toolbar-dropdown-text">To front</span>
                    </li>
                    <li className="toolbar-dropdown-item" onClick={(e) => {if(!this.state.layer_buttons.bottom){(this.update_inputs_general(e,'layer_down'))}}}>
                        <Image style={{ height: 8 }} src={global.config.static_file_server_path + 'uploads/icons/backward.svg'} />
                        <span className="toolbar-dropdown-text">Backward</span>
                    </li>
                    <li className="toolbar-dropdown-item" onClick={(e) => {if(!this.state.layer_buttons.bottom){(this.update_inputs_general(e,'send_back'))}}}>
                        <Image style={{ height: 12 }} src={global.config.static_file_server_path + 'uploads/icons/to_back.svg'} />
                        <span className="toolbar-dropdown-text">To back</span>
                    </li>
                </ul>
                <div style={{ width: '100%', height: 10 }}></div>
                <span style={dropdown_heading_style} > Align to page </span>
                <ul className="toolbar-dropdown two-column-dropdown">
                    <li className="toolbar-dropdown-item" onClick={(e) => {(this.update_inputs_general(e,'position_top'))}}>
                        <Image style={{ height: 12 }} src={global.config.static_file_server_path + 'uploads/icons/page_align_top.svg'} />
                        <span className="toolbar-dropdown-text">Top</span>
                    </li>
                    <li className="toolbar-dropdown-item" onClick={(e) => {(this.update_inputs_general(e,'position_middle'))}}>
                        <Image style={{ height: 12 }} src={global.config.static_file_server_path + 'uploads/icons/page_align_middle.svg'} />
                        <span className="toolbar-dropdown-text">Middle</span>
                    </li>
                    <li className="toolbar-dropdown-item" onClick={(e) => {(this.update_inputs_general(e,'position_bottom'))}}>
                        <Image style={{ height: 12 }} src={global.config.static_file_server_path + 'uploads/icons/page_align_bottom.svg'} />
                        <span className="toolbar-dropdown-text">Bottom</span>
                    </li>
                    <li className="toolbar-dropdown-item" onClick={(e) => {(this.update_inputs_general(e,'position_left'))}}>
                        <Image style={{ height: 12 }} src={global.config.static_file_server_path + 'uploads/icons/page_align_left.svg'} />
                        <span className="toolbar-dropdown-text">Left</span>
                    </li>
                    <li className="toolbar-dropdown-item" onClick={(e) => {(this.update_inputs_general(e,'position_center'))}}>
                        <Image style={{ height: 12 }} src={global.config.static_file_server_path + 'uploads/icons/page_align_center.svg'} />
                        <span className="toolbar-dropdown-text">Center</span>
                    </li>
                    <li className="toolbar-dropdown-item" onClick={(e) => {(this.update_inputs_general(e,'position_right'))}}>
                        <Image style={{ height: 12 }} src={global.config.static_file_server_path + 'uploads/icons/page_align_right.svg'} />
                        <span className="toolbar-dropdown-text">Right</span>
                    </li>
                </ul>
            </div>
        )

        const Opacity_Dropdown_trigger = ({ toggle_dropdown }) => (
            <Button className="btn-toolbar" onClick={() => toggle_dropdown()} style={{ 'marginRight': '5px', outline: 'none', cursor: 'pointer' }}>
                <Image style={{ height: 20 }} src={global.config.static_file_server_path + 'uploads/icons/opacity.svg'} />
            </Button>
        )

        const Opacity_Dropdown_dropper = () => (
            <ul className="toolbar-dropdown no-hover">
                <li className="toolbar-dropdown-item no-hover" >
                    <input 
                        className="toolbar-range-input no-hover" type="range" min="1" max="100" id="zoom_slider"
                        onChange={(e) => {this.update_inputs_general(e.target.value,'opacity')}}
                        value={this.state.design_selection?(this.state.design_selection.get_parent('grid')? (String(this.state.design_selection.get_parent('grid').opacity*100)) : (String(this.state.design_selection.opacity*100))):"100"} 
                    />
                </li>
            </ul>
        )

        return (
            <Col xs={col_width} className="text-right" style={{'display':'inline'}}>
                {this.state.design_selection && this.state.design_selection!=window.design_editor.temporary_group && (this.state.design_selection.type == 'group' || (this.state.design_selection.getGroup() && this.state.design_selection.getGroup()!=window.design_editor.temporary_group)) && (
                    <Button className="btn-toolbar" style={{'marginRight': '5px',}} onClick={(e) => {this.update_inputs_general(e,'ungroup')}}>Ungroup</Button>
                )}
                {this.state.design_selection && (this.state.design_selection==window.design_editor.temporary_group || (this.state.design_selection.getGroup()==window.design_editor.temporary_group && window.design_editor.temporary_group!=null)) && (!window.design_editor.group_already_exists(window.design_editor.temporary_group)) && (
                    <Button className="btn-toolbar" style={{'marginRight': '5px',}} onClick={(e) => {this.update_inputs_general(e,'group')}}>Group</Button>
                )}
                {/* <DropdownButton id="swijisjisjisw" key={1} className="btn-toolbar" style={{'marginRight': '5px',marginLeft:'5px'}} title="Position"> */}
                {/*     <MenuItem eventKey={1} onClick={(e) => {if(!this.state.layer_buttons.top){(this.update_inputs_general(e,'layer_up'))}}}>Forward</MenuItem> */}
                {/*     <MenuItem eventKey={1} onClick={(e) => {if(!this.state.layer_buttons.top){(this.update_inputs_general(e,'bring_front'))}}}>To front</MenuItem> */}
                {/*     <MenuItem eventKey={2} onClick={(e) => {if(!this.state.layer_buttons.bottom){(this.update_inputs_general(e,'layer_down'))}}}>Backward</MenuItem> */}
                {/*     <MenuItem eventKey={2} onClick={(e) => {if(!this.state.layer_buttons.bottom){(this.update_inputs_general(e,'send_back'))}}}>To back</MenuItem> */}
                {/*     <MenuItem divider /> */}
                {/*     <MenuItem eventKey={2} onClick={(e) => {(this.update_inputs_general(e,'position_top'))}}>Top</MenuItem> */}
                {/*     <MenuItem eventKey={2} onClick={(e) => {(this.update_inputs_general(e,'position_middle'))}}>Middle</MenuItem> */}
                {/*     <MenuItem eventKey={2} onClick={(e) => {(this.update_inputs_general(e,'position_bottom'))}}>Bottom</MenuItem> */}
                {/*     <MenuItem eventKey={2} onClick={(e) => {(this.update_inputs_general(e,'position_left'))}}>Left</MenuItem> */}
                {/*     <MenuItem eventKey={2} onClick={(e) => {(this.update_inputs_general(e,'position_center'))}}>Center</MenuItem> */}
                {/*     <MenuItem eventKey={2} onClick={(e) => {(this.update_inputs_general(e,'position_right'))}}>Right</MenuItem> */}
                {/* </DropdownButton> */}
                <OverlayTrigger delayShow={400} placement="bottom" overlay={tooltips['position']}><div style={{ display: 'inline-block' }}>
                    <ManateeDropdown 
                        container_style={{ display: 'inline-block' }}
                        dropper_container_style = {{ borderRadius: 3 }}
                        Trigger={Position_Dropdown_trigger}
                        Dropper={Position_Dropdown_dropper}
                    />
                </div></OverlayTrigger>
                <OverlayTrigger delayShow={400} placement="bottom" overlay={tooltips['transparency']}><div style={{ display: 'inline-block' }}>
                    <ManateeDropdown 
                        container_style={{ display: 'inline-block' }}
                        Trigger={Opacity_Dropdown_trigger}
                        Dropper={Opacity_Dropdown_dropper}
                    />
                </div></OverlayTrigger>
                <Button className="btn-toolbar" onClick={(e) => {this.update_inputs_general(e,'copy_and_paste')}} style={{ 'marginRight': '5px', outline: 'none', cursor: 'pointer' }}>
                    <Image style={{ height: 20 }} src={global.config.static_file_server_path + 'uploads/icons/copy.svg'} />
                </Button>
                {/* <DropdownButton */}
                {/*     id="swjiuwjiujiuhy" */}
                {/*     pullRight={true} */}
                {/*     className="btn-toolbar btn-toolbar-square" */}
                {/*     style={{'marginRight': '5px'}} */}
                {/*     title=<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="currentColor" fillRule="evenodd"><path d="M3 2h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm0 8h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1zm0 8h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1z"></path><path d="M11 2h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm0 8h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1zm0 8h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1z" opacity=".45"></path><path d="M19 2h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm0 8h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1zm0 8h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1z" opacity=".15"></path><path d="M7 6h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zm0 8h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1z" opacity=".7"></path><path d="M15 6h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zm0 8h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1z" opacity=".3"></path></g></svg> */}
                {/*     > */}
                {/*     <MenuItem className="disable-hover-bg" style={{paddingTop:"10px",paddingBottom:"10px"}} draggable="false"> */}
                {/*         <input className="disable-hover-bg" type="range" min="1" max="100" id="zoom_slider" onChange={(e) => {this.update_inputs_general(e.target.value,'opacity')}} value={this.state.design_selection&&this.state.design_selection.opacity?String(this.state.design_selection.opacity*100):"100"}  /> */}
                {/*     </MenuItem> */}
                {/* </DropdownButton> */}
                <OverlayTrigger delayShow={400} placement="bottom" overlay={(this.state.design_selection&&(this.state.design_selection.locked || (this.state.design_selection.get_parent('grid') && this.state.design_selection.get_parent('grid').locked) || (this.state.design_selection.getGroup() && (this.state.design_selection.getGroup().locked || this.state.design_selection.getGroup().group_details.object_data.find(o => o.object.locked))) ) ? tooltips['lock'] : tooltips['unlock'])}>
                    <Button className="btn-toolbar" onClick={(e) => {this.update_inputs_general(e,'lock')}} style={{ 'marginRight': '5px', outline: 'none', cursor: 'pointer' }}>
                        <Image style={{ height: 20 }} src={global.config.static_file_server_path + (this.state.design_selection&&(this.state.design_selection.locked || (this.state.design_selection.get_parent('grid') && this.state.design_selection.get_parent('grid').locked) || (this.state.design_selection.getGroup() && (this.state.design_selection.getGroup().locked || this.state.design_selection.getGroup().group_details.object_data.find(o => o.object.locked))) ) ? 'uploads/icons/lock.svg' : 'uploads/icons/unlock.svg')} />
                    </Button>
                </OverlayTrigger>
                <OverlayTrigger delayShow={400} placement="bottom" overlay={tooltips['delete']}>
                    <Button className="btn-toolbar" onClick={(e) => {this.update_inputs_general(e,'delete')}} style={{ 'marginRight': '5px', outline: 'none', cursor: 'pointer' }}>
                        <Image style={{ height: 20 }} src={global.config.static_file_server_path + 'uploads/icons/trash.svg'} />
                    </Button>
                </OverlayTrigger>
                {/* <Button className="btn-toolbar btn-toolbar-square" style={{'marginRight': '5px', 'backgroundImage': 'none', 'border': 'none'}} onClick={(e) => {this.update_inputs_general(e,'lock')}} ><span className={this.state.design_selection&&(this.state.design_selection.locked || (this.state.design_selection.getGroup() && (this.state.design_selection.getGroup().locked || this.state.design_selection.getGroup().group_details.object_data.find(o => o.object.locked))) )?"fa fa-lg fa-lock":"fa fa-lg fa-unlock"}></span></Button> */}
                {/* <Button onClick={(e) => {this.update_inputs_general(e,'delete')}} className="btn-toolbar btn-toolbar-square" style={{'marginRight': '5px', 'backgroundImage': 'none', 'border': 'none'}}><span className="fa fa-lg fa-trash-alt"></span></Button> */}
            </Col>             
        )
    }

    handleClickGridColorPicker = () => {
        this.setState({ displayGridColorPicker: !this.state.displayGridColorPicker })
    };

    handleCloseGridColorPicker = () => {
        this.setState({ displayGridColorPicker: false })
    };

    _crop_mode_options_panel = () => {
        return (
            <Row className="d-flex align-items-center" style={{padding: 5, backgroundColor: '#F1F2F3', zIndex :1010}}>
                <Col xs={12} style={{'display':'inline',paddingLeft:'0'}}>
                    <div style={{display:'flex',flexFlow:'row'}}>
                        <Button className="btn-toolbar" style={{'marginRight': '5px'}} onClick={this.crop_mode_done}>Done</Button>
                        <Button className="btn-toolbar" style={{'marginRight': '5px'}} onClick={this.crop_mode_cancel}>Cancel</Button>
                    </div>
                </Col>
            </Row>
        );
    }

    _grid_options_panel = () => {
        const styles = reactCSS({
            'default': {
              color: {
                width: '30px',
                height: '30px',
                borderRadius: '15px',
                'border': '1px',
                background: this.state.design_selection&&this.state.design_selection.get_parent('box')&&this.state.design_selection.get_parent('box').color?this.state.design_selection.get_parent('box').color:'#999999',
              },
              swatch: {
                padding: '2.5px',
                borderRadius: '15px',
                display: 'inline-block',
                cursor: 'pointer',
              },
              popover: {
                position: 'absolute',
                zIndex: '2',
              },
              cover: {
                position: 'fixed',
                top: '0px',
                right: '0px',
                bottom: '0px',
                left: '0px',
                zIndex: '-1'
              },
            },
        });

        const handleLabelChange = (e) => {
            this.setState({grid_bulk_edit_label_temp: e.target.value});
        }

        const handleSpaceBar = (e) => {
            if(e.key == " "){
                e.preventDefault();
                e.stopPropagation();
                this.setState({grid_bulk_edit_label_temp: this.state.grid_bulk_edit_label_temp + " "});
            }
        }
    
        const get_current_label = () => {
            if(this.state.design_selection && this.state.design_selection.get_parent('box') && this.state.design_selection.get_parent('box').image && this.state.design_selection.get_parent('box').image.user_labels && this.state.design_selection.get_parent('box').image.user_labels["image"]){
                var label_id = this.state.design_selection.get_parent('box').image.user_labels["image"];
                var label_find = window.design_editor.design.bulk_edit_data.labels.find(o => {return o.id == label_id})
                if(label_find){
                    return label_find.text
                }
            }
            return "";
        }
    
        const bulk_edit_on_click = async () => {
            if(get_current_label() == "" && this.state.grid_bulk_edit_label_temp != ""){
                console.log(this.state.design_selection)
                if(this.state.design_selection && this.state.design_selection.get_parent('box') && this.state.design_selection.get_parent('box').image && this.state.design_selection.get_parent('box').image.user_labels){
                    var sel = this.state.design_selection.get_parent('box').image;
                    var new_label_id = window.utils.uuidv4()
                    window.design_editor.design.bulk_edit_data.labels.push({
                        id: new_label_id, text: this.state.grid_bulk_edit_label_temp, assigned: [sel.id], selected: true, type: 'image'
                    });
                    
                    sel.user_labels["image"] = new_label_id;
                    window.design_editor.addUndoChange()
                }
                this.setState({});
            }
    
            await this.switch_nav_tab("");
            await this.switch_nav_tab("bulk_edit");
        }
    
        const bulk_edit_toggle = (isOpen, e) => {
            if(e.target.type != 'text'){
                this.setState({grid_bulk_edit_open:isOpen})
            }
        }

        const Dropdown_trigger = ({ toggle_dropdown }) => (
            <Button className="btn-toolbar" onClick={() => toggle_dropdown()} style={{ 'marginRight': '5px', outline: 'none', cursor: 'pointer' }}>
                <Image style={{ height: 20 }} src={global.config.static_file_server_path + 'uploads/icons/flip_vertically.svg'} />
            </Button>
        )

        const Dropdown_dropper = () => (
            <ul className="toolbar-dropdown">
                <li className="toolbar-dropdown-item" onClick={(e) => {this.update_inputs_grid(e,'flip_horizontal')}}>
                    <Image style={{ height: 20 }} src={global.config.static_file_server_path + 'uploads/icons/flip_horizontally.svg'} />
                    <span className="toolbar-dropdown-text">Flip Horizontal</span>
                </li>
                <li className="toolbar-dropdown-item" onClick={(e) => {this.update_inputs_grid(e,'flip_vertical')}}>
                    <Image style={{ height: 20 }} src={global.config.static_file_server_path + 'uploads/icons/flip_vertically.svg'} />
                    <span className="toolbar-dropdown-text">Flip Vertical</span>
                </li>
            </ul>
        )

        const Enhance_Dropdown_trigger = ({ toggle_dropdown }) => (
            <Button className="btn-toolbar" onClick={() => toggle_dropdown()} style={{ 'marginRight': '5px', outline: 'none', cursor: 'pointer' }}>
                <Image style={{ height: 20 }} src={global.config.static_file_server_path + 'uploads/icons/image_enhance.svg'} />
            </Button>
        )

        const Enhance_Dropdown_dropper = () => (
            <ul className="toolbar-dropdown">
                <li className="toolbar-dropdown-item" onClick={(e) => {this.switch_nav_tab('filters')}}>
                    <Image style={{ height: 20 }} src={global.config.static_file_server_path + 'uploads/icons/image_filter.svg'} />
                    <span className="toolbar-dropdown-text">Filter                               </span>
                </li>
                <li className="toolbar-dropdown-item" onClick={this.adjustmentPanelOnclick}>
                    <Image style={{ height: 20 }} src={global.config.static_file_server_path + 'uploads/icons/image_brightnesscontrast.svg'} />
                    <span className="toolbar-dropdown-text">Adjustment</span>
                </li>
                <li className="toolbar-dropdown-item" onClick={this.shadowsPanelOnClick}>
                    <span className="toolbar-dropdown-text">Shadows</span>
                </li>
                {/*(this.state.design_selection&&this.state.design_selection.get_parent('box')&&this.state.design_selection.get_parent('box').image)?(
                    <li className="toolbar-dropdown-item" onClick={this.backgroundRemovalPanelOnclick}>
                        <Image style={{ height: 20 }} src={global.config.static_file_server_path + 'uploads/icons/image_bg_remove.svg'} />
                        <span className="toolbar-dropdown-text">Remove Background</span>
                    </li>
                ):''*/}
                {/*(this.state.design_selection&&this.state.design_selection.get_parent('box')&&this.state.design_selection.get_parent('box').image&&this.state.design_selection.get_parent('box').image.sub_type=='mockup')?(
                    <li className="toolbar-dropdown-item" onClick={this.mockupEditorPanelOnclick}>
                        <Image style={{ height: 20 }} src={global.config.static_file_server_path + 'uploads/icons/Mockup.svg'} />
                        <span className="toolbar-dropdown-text">Edit Mockup</span>
                    </li>
                ):''*/}
            </ul>
        )

        return (
            <Row className="d-flex align-items-center" style={{padding: 5, backgroundColor: '#F1F2F3', zIndex :1010}}>
                <Col xs={6} style={{'display':'inline',zIndex:"10000"}}>
                    {(this.state.design_selection&&this.state.design_selection.get_parent('box')&&this.state.design_selection.get_parent('box').image)?(
                        <div style={{display:'flex',flexFlow:'row'}}>
                            {this.state.design_selection&&this.state.design_selection.get_parent('box')&&this.state.design_selection.get_parent('box').image&&this.state.design_selection.get_parent('box').image.sub_type=='mockup'?(
                                <OverlayTrigger delayShow={400} placement="bottom" overlay={tooltips['edit_mockup']}>
                                    <Button className="btn-toolbar" onClick={this.mockupEditorPanelOnclick} style={{ 'marginRight': '5px', outline: 'none', cursor: 'pointer' }}>
                                        <Image style={{ height: 20 }} src={global.config.static_file_server_path + 'uploads/icons/Mockup.svg'} />
                                    </Button>
                                </OverlayTrigger>
                            ):''}
                            <OverlayTrigger delayShow={400} placement="bottom" overlay={tooltips['photo_editor']}><div>
                                <ManateeDropdown 
                                    Trigger={Enhance_Dropdown_trigger}
                                    Dropper={Enhance_Dropdown_dropper}
                                />
                            </div></OverlayTrigger>
                            <OverlayTrigger delayShow={400} placement="bottom" overlay={tooltips['crop']}>
                                <Button className="btn-toolbar" onClick={this.enter_crop_mode} style={{ 'marginRight': '5px', outline: 'none', cursor: 'pointer' }}>
                                    <Image style={{ height: 20 }} src={global.config.static_file_server_path + 'uploads/icons/crop_temp.svg'} />
                                </Button>
                            </OverlayTrigger>
                            <OverlayTrigger delayShow={400} placement="bottom" overlay={tooltips['flip']}><div>
                                <ManateeDropdown 
                                    Trigger={Dropdown_trigger}
                                    Dropper={Dropdown_dropper}
                                />
                            </div></OverlayTrigger>
                            {(this.state.design_selection&&this.state.design_selection.get_parent('box')&&this.state.design_selection.get_parent('box').image)?(
                                <OverlayTrigger delayShow={400} placement="bottom" overlay={tooltips['bg_removal']}>
                                    <Button className="btn-toolbar" onClick={this.toggle_background_removal} style={{ 'marginRight': '5px', outline: 'none', cursor: 'pointer' }}>
                                        <Image style={{ height: 20 }} src={this.state.design_selection.get_parent('box').image.bgremoval.enabled?global.config.static_file_server_path + 'uploads/icons/image_bg_remove_cancel.svg':global.config.static_file_server_path + 'uploads/icons/image_bg_remove.svg'} />
                                    </Button>
                                </OverlayTrigger>
                            ):''}
                            {global.config.application_env != "" && (<OverlayTrigger delayShow={400} placement="bottom" overlay={tooltips['animate']}>
                                <Button className="btn-toolbar" onClick={this.animateOnClick} style={{ 'marginRight': '5px', outline: 'none', cursor: 'pointer' }}>
                                    <Image style={{ height: 20 }} src={null} />
                                    Animate
                                </Button>
                            </OverlayTrigger>)}
                            <DropdownButton
                                pullLeft={true}
                                className="btn-toolbar" 
                                style={{'marginRight': '5px'}}                    
                                title="Bulk Label"
                                open={this.state.grid_bulk_edit_open}
                                onToggle={bulk_edit_toggle}
                                >
                                    <MenuItem className="disable-hover-bg" style={{paddingTop:"10px",paddingBottom:"10px",width:'300px'}} draggable="false">
                                        <Row>
                                            <Col xs={2}>
                                                <Image style={{ height: 30, float:"right"}} src={global.config.static_file_server_path + 'uploads/icons/Photos.svg'} />
                                            </Col>
                                            <Col xs={10} style={{paddingLeft:0, paddingRight:0}}>
                                                {/* <InputGroup style={{border: "1px solid grey",width:"100%"}}> */}
                                                    {get_current_label()==""?(<input
                                                        key={"create_new_label"}
                                                        value={this.state.grid_bulk_edit_label_temp}
                                                        style={{border: "1px solid grey",width:"100%",fontSize: 14, fontFamily: 'Montserrat', height: 30, borderRadius: 0}}
                                                        placeholder={'Enter a label'}
                                                        type="text"
                                                        onKeyUp={(e) => handleSpaceBar(e)}
                                                        onChange={(e) => handleLabelChange(e)}
                                                    />):(<input
                                                        key={"manage_labels"}
                                                        style={{border: "1px solid grey",width:"100%",fontSize: 14, fontFamily: 'Montserrat', height: 30, borderRadius: 0}}
                                                        placeholder={'Enter a label'}
                                                        value={get_current_label()}
                                                        type="text"
                                                        disabled={true}
                                                        // onChange={(e) => handleChange(id, e)}
                                                    />)}
                                                {/* </InputGroup> */}
                                            </Col>
                                        </Row>
                                    </MenuItem>
                                    <MenuItem className="disable-hover-bg" style={{display:"flex",justifyContent:"center",paddingTop:"10px",paddingBottom:"10px"}} draggable="false">
                                        <Button onClick={bulk_edit_on_click} className="btn btn-sm btn-block btn-orange" style={{textAlign: 'center'}}>{get_current_label()!=""?"Manage Labels":" OK "}</Button>
                                    </MenuItem>
                            </DropdownButton>
                        </div>
                    ):(
                        <div >
                            <div style={ styles.swatch } onClick={ this.handleClickGridColorPicker }>
                            <div style={ styles.color } />
                            </div>
                            { this.state.displayGridColorPicker ? <div style={ styles.popover }>
                            <div style={ styles.cover } onClick={ this.handleCloseGridColorPicker }/>
                            <Colour_Picker user={this.props.user}  presetColors={['#ffffff','#f3ec3a','#f9bd17','#f99b1d','#f15523','#ef3124','#DE0081','#a71e48','#7c3597','#463191','#000000','#3d5dac','#1296ce','#63b145','#19BC81','#d0dd36']} disableAlpha={true} color={styles.color.background} onChange={ (e) => {this.update_inputs_grid(e,'color') }} />
                            </div> : null }
                        </div>
                    )
                }
                </Col>
                {this._rhs_options_panel()}          
            </Row>
        );
    }

    setDesignName = (e) => {
        this.setState({designName: e.target.value});
    }

    setDesignNameEnter = (e) => {
        if (e.key == 'Enter') {
            update_design_name(this.props.match.params.design_id, this.state.designName)
                .catch(err => {
                    console.error(err);
                })
        }
    };

    resize_options = []

    update_resize_options = (e) => {
        var current_dimensions = this.state.resize_dimensions

        if(e.target.checked){
            current_dimensions[e.target.id] = true
        }else{
            delete current_dimensions[e.target.id]
        }

        this.setState({
            resize_dimensions : current_dimensions
        })
    }

    handle_design_resources_search = (e) => {
        this.setState({
            search_text: e.target.value
        })
        if (e.target.value === "") {
            this.setState({
                search_active : false
            })
        }
    }

    AllTabs = () => {
        try {

            if (this.state.active_nav_tab) {

                switch(this.state.active_nav_tab) {
                    case 'templates' : return (
                        <Tab.Pane eventKey="templates">
                            <TemplatesPanel
                                rct_update_pages= {this.rct_update_pages}
                                defaultCategory={this.state.defaultCategory}
                            />

                        </Tab.Pane>
                    );

                    case 'mockups' : return (
                        <Tab.Pane eventKey="mockups">
                            <Row>
                                <Col xs={6} style={{padding: 0}}>
                                    <Button className={"btn-lg btn-block btn photo-tab-btn" + (this.state.activeMockupTab === 1 ? " selected" : "")} style={{fontSize:'14px'}} onClick={() => this.setState({'activeMockupTab': 1})}>Explore</Button>
                                </Col>
                                <Col xs={6} style={{padding: 0}}>
                                    <Button  className={"btn-lg btn-block btn photo-tab-btn" + (this.state.activeMockupTab === 2 ? " selected" : "")} style={{fontSize:'14px'}} onClick={() => {this.setState({'activeMockupTab': 2})}}>Saved Mockups</Button>
                                </Col>
                            </Row>

                            {(this.state.activeMockupTab === 1)?
                                (<MockupsPanel
                                    on_drag_start={this.image_drag_start} 
                                    on_drag={this.image_drag}
                                    on_drag_end={this.image_drag_end}
                                    on_click={this.add_image}
                                />):
                                (<React.Fragment>
                                    <div className="thin_scroll" style={{height: 'calc(100vh - 110px)', width: "100%", overflowY: 'auto'}}>
                                        <FormControl type="file" style={{"display": "none"}} onChange={event => this.upload_file(event.target.files[0])} id="custom_upload" name="upload" placeholder="Upload File" />
                                        <DesignResourcesPanel on_drag_start={this.image_drag_start} on_drag={this.image_drag} on_drag_end={this.image_drag_end} on_click={this.add_image} image_height={'126px'} col_size={6} resources={this.state.saved_mockups ? this.state.saved_mockups.map(x => ({mockup_id:x.mockup._id,inputs:x.mockup_inputs,src: x.watermarked_output_src})) : []}/>
                                    </div> 
                                </React.Fragment>)}
                        </Tab.Pane>
                    );

                    case 'brand_kit' : return (
                        <Tab.Pane eventKey="brand_kit">
                            <BrandKitPanel font_sets={this.state.brandkit_font_sets} color_palettes={this.state.brandkit_color_palettes}  />
                        </Tab.Pane>
                    );

                    case 'photos' : return (
                        <Tab.Pane eventKey="photos">
                            {/* <Row>
                                <Col xs={6} style={{padding: 0}}>
                                    <Button className={"btn-lg btn-block btn photo-tab-btn" + (this.state.activePhotoTab === 1 ? " selected" : "")} style={{fontSize:'14px'}} onClick={() => this.setState({'activePhotoTab': 1})}><Image height={30} src={global.config.static_file_server_path + 'uploads/icons/silver_crown.svg'} /></Button>
                                </Col>
                                <Col xs={6} style={{padding: 0}}>
                                    <Button  className={"btn-lg btn-block btn photo-tab-btn" + (this.state.activePhotoTab === 2 ? " selected" : "")} style={{fontSize:'14px'}} onClick={() => {this.setState({'activePhotoTab': 2})}}><Image height={30} src={global.config.static_file_server_path + 'uploads/icons/gold_crown.svg'} /></Button>
                                </Col>
                            </Row> */}

                            {/* <RfImagePanel 
                                on_drag_start={this.image_drag_start} 
                                on_drag={this.image_drag}
                                on_drag_end={this.image_drag_end}
                                on_click={this.add_image}
                                annotation_text={this.state.activePhotoTab === 1?(this.state.photos_subscription?"INCLUDED":"PREMIUM ($1)"):(this.state.photos_subscription?"1 CREDIT":"PREMIUM ($1)")}
                                rf_type_key={this.state.activePhotoTab==1?"123RF_PLUS":"123RF"}
                                key={this.state.activePhotoTab==1?"123RF_PLUS":"123RF"}
                            /> */}

                            <ImageMakerPanel 
                                on_drag_start={this.image_drag_start} 
                                on_drag={this.image_drag}
                                on_drag_end={this.image_drag_end}
                                on_click={this.add_image}
                            />

                                {/* <PixlrPanel
                                    on_drag_start={this.image_drag_start} 
                                    on_drag={this.image_drag}
                                    on_drag_end={this.image_drag_end}
                                    on_click={this.add_image}
                                    annotation_text={this.state.photos_subscription?"INCLUDED":"PREMIUM ($1)"}
                                /> */}
                                {/* <StockUnlimitedPanel
                                    on_drag_start={this.image_drag_start} 
                                    on_drag={this.image_drag}
                                    on_drag_end={this.image_drag_end}
                                    on_click={this.add_image}
                                /> */}

                        </Tab.Pane>
                    );

                    case 'backgrounds' : return (
                        <Tab.Pane eventKey="backgrounds">
                             <Row>
                                <Col xs={6} style={{padding: 0}}>
                                    <Button className={"btn-lg btn-block btn photo-tab-btn" + (this.state.activeBackgroundTab === 0 ? " selected" : "")} style={{fontSize:'14px'}} onClick={() => this.setState({'activeBackgroundTab': 0})}>Common</Button>
                                </Col>
                                <Col xs={6} style={{padding: 0}}>
                                    <Button  className={"btn-lg btn-block btn photo-tab-btn" + (this.state.activeBackgroundTab === 1 ? " selected" : "")} style={{fontSize:'14px'}} onClick={() => {this.setState({'activeBackgroundTab': 1})}}>Imagemaker</Button>
                                </Col>
                            </Row>
                            {
                                 this.state.activeBackgroundTab === 0 && 
                                 <BackgroundPanel 
                                    on_drag_start={this.background_drag_start} 
                                    on_drag={this.background_drag}
                                    on_drag_end={this.background_drag_end}
                                    on_click={this.load_background}
                                />
                            }{
                                this.state.activeBackgroundTab === 1 && 
                                <ImageMakerPanel 
                                    on_drag_start={this.image_drag_start} 
                                    on_drag={this.image_drag}
                                    on_drag_end={this.image_drag_end}
                                    on_click={this.load_background}
                                    systemPrompt="A background image based on"
                                />
                            }
                        </Tab.Pane>
                    );

                    case 'elements' : return (
                        <Tab.Pane eventKey="elements" style={{height: 'calc(100vh) - 149px'}}> 
                           <ElementsPanel user_details={this.state.user_details} add_image={this.add_image} image_drag_start={this.image_drag_start} image_drag={this.image_drag} image_drag_end={this.image_drag_end} />
                        </Tab.Pane>
                    );

                    case 'text' : return (
                        <Tab.Pane eventKey="text">
                            <Image
                                src={global.config.static_file_server_path+'uploads/add_heading.png'}
                                style={{cursor:'pointer',marginBottom:8,width:'85%',display:'block',textAlign:'left',marginLeft:13}}
                                onClick={() => {this.load_text(this.hardcoded_text_fields[0])}}
                                onDragStart={(e) => {this.text_drag_start(this.hardcoded_text_fields[0],e)}}
                                onDrag={(e) => {this.text_drag(this.hardcoded_text_fields[0],e)}}
                                onDragEnd={(e) => {this.text_drag_end(this.hardcoded_text_fields[0],e)}}
                                className="unselectable"
                            />
                            <Image
                                src={global.config.static_file_server_path+'uploads/add_subheading.png'}
                                style={{cursor:'pointer',marginBottom:13,width:'75%',display:'block',textAlign:'left',marginLeft:13}}
                                onClick={() => {this.load_text(this.hardcoded_text_fields[1])}}
                                onDragStart={(e) => {this.text_drag_start(this.hardcoded_text_fields[1],e)}}
                                onDrag={(e) => {this.text_drag(this.hardcoded_text_fields[1],e)}}
                                onDragEnd={(e) => {this.text_drag_end(this.hardcoded_text_fields[1],e)}}
                                className="unselectable"
                            />
                            <Image
                                src={global.config.static_file_server_path+'uploads/add_paragraph.png'}
                                style={{cursor:'pointer',marginBottom:5,width:'60%',display:'block',textAlign:'left',marginLeft:13}}
                                onClick={() => {this.load_text(this.hardcoded_text_fields[2])}}
                                onDragStart={(e) => {this.text_drag_start(this.hardcoded_text_fields[2],e)}}
                                onDrag={(e) => {this.text_drag(this.hardcoded_text_fields[2],e)}}
                                onDragEnd={(e) => {this.text_drag_end(this.hardcoded_text_fields[2],e)}}
                                className="unselectable"
                            />
                            
                            {this.state.search_active ? (   
                                <InfiniteScroll 
                                    dataLength={this.state.search_results_display ? this.state.search_results_display.length : 0}
                                    next= {this.fetch_next_search_results}
                                    hasMore={true}
                                    endMessage={<h4>No more results.</h4>} 
                                    height={'calc(100vh - 265px)'}
                                >
                                    <DesignResourcesPanel on_drag_start={this.text_template_drag_start} on_drag={this.text_template_drag} on_drag_end={this.text_template_drag_end} on_click={this.load_text_template} image_height={'126px'} col_size={6} resources={this.state.search_results_display}/>
                                </InfiniteScroll>
                            ) : (
                                <InfiniteScroll
                                    dataLength={this.state.design_resources_text_templates.data ? this.state.design_resources_text_templates.data.length : 0}
                                    next= {this.fetch_more_text_templates}
                                    hasMore={true}
                                    endMessage={<h4>No more results.</h4>} 
                                    height={'calc(100vh - 265px)'}
                                >
                                <DesignResourcesPanel on_drag_start={this.text_template_drag_start} on_drag={this.text_template_drag} on_drag_end={this.text_template_drag_end} on_click={this.load_text_template} image_height={'126px'} col_size={6} resources={this.state.design_resources_text_templates.data}/>
                            </InfiniteScroll>
                            )}

                             
                        </Tab.Pane>
                    );

                    case 'uploads' : return (
                        <Tab.Pane eventKey="uploads">
                            <div style={{height : 20}}>
                            </div>
                            <div style={{paddingLeft: 12, paddingRight: 12, paddingBottom: 12, width: '100%'}}>
                                {this.props.user ? (
                                    <Button className="btn btn-sm btn-block btn-orange" style={{paddingTop: 9, paddingBottom: 9}} onClick={() => {window.document.getElementById('custom_upload').click()}}>UPLOAD IMAGE</Button>
                                ):(
                                    <span>Please log in to use this feature</span>
                                )}
                            </div>
                            <div className="thin_scroll" style={{height: 'calc(100vh - 199px)', width: "100%", overflowY: 'auto'}}>
                                <FormControl type="file" style={{"display": "none"}} onChange={event => this.upload_file(event.target.files[0])} id="custom_upload" name="upload" placeholder="Upload File" />
                                <DesignResourcesPanel 
                                    on_drag_start={this.image_drag_start} 
                                    on_drag={this.image_drag} 
                                    on_drag_end={this.image_drag_end} 
                                    on_click={this.add_image} 
                                    image_height={'126px'} 
                                    col_size={6} 
                                    resources={this.state.uploads ? this.state.uploads : []}
                                    contextMenu={this.generate_thumbnails_context_menu}
                                    showContextMenu={true}
                                />
                            </div>                                            
                        </Tab.Pane>
                    );

                    case 'filters' : return (
                        <Tab.Pane eventKey="filters">
                            <Row style={{ width: "100%", height: "calc(100vh - 149px)",overflowY:"auto"}}>
                                <Col xs={12} style={{ display : 'table', 'marginBottom' : 10, paddingTop : 5 }}>
                                </Col>
                                <this.FiltersPanel/>
                            </Row>                                     
                        </Tab.Pane>
                    );

                    case 'adjust' : return (
                        <Tab.Pane eventKey="adjust">
                            <Row style={{ width: "100%", height: "calc(100vh - 149px)",overflowY:"auto"}}>
                                <AdjustmentPanel
                                    apply_filter_adjustments = {this.apply_filter_adjustments}
                                    switch_nav_tab = {this.switch_nav_tab}
                                    ref={this.adjustmentPanelRef}
                                />
                            </Row>
                        </Tab.Pane>
                    );

                    case 'text_effects' : return (
                        <Tab.Pane eventKey="text_effects">
                            <Row style={{ width: "100%", height: "calc(100vh - 149px)",overflowY:"auto"}}>
                                <TextEffectsPanel
                                    apply_text_effects = {this.apply_text_effects}
                                    switch_nav_tab = {this.switch_nav_tab}
                                    ref={this.textEffectsPanelRef}
                                />
                            </Row>
                        </Tab.Pane>
                    );

                    case 'remove_background' : return (
                        <Tab.Pane eventKey="remove_background">
                            <Row style={{ width: "100%", height: "calc(100vh - 149px)",overflowY:"auto"}}>
                                <BackgroundRemovalPanel
                                    apply_background_removal = {this.apply_background_removal}
                                    switch_nav_tab = {this.switch_nav_tab}
                                    ref={this.backgroundRemovalPanelRef}
                                />
                            </Row>
                        </Tab.Pane>
                    );

                    case 'mockup_editor' : return (
                        <Tab.Pane eventKey="mockup_editor">
                            <Row style={{ width: "100%", height: "calc(100vh - 149px)",overflowY:"auto"}}>
                                <MockupEditorPanel
                                    apply_mockup_editor = {this.apply_mockup_editor}
                                    ref={this.mockupEditorPanelRef}
                                    user={this.props.user}
                                />
                            </Row>
                        </Tab.Pane>
                    );
                    

                    case 'fonts' : return (
                        <Tab.Pane eventKey="fonts">
                            <FontsPanel
                               update_inputs_text = {this.update_inputs_text}
                               show_brand_kit_fonts = {true}
                               brandkit_font_sets={this.state.brandkit_font_sets}
                            />                                    
                        </Tab.Pane>
                    );

                    case 'folders' : return (
                        <Tab.Pane eventKey="folders">
                            <Row style={{ width: "100%", height: "calc(100vh - 149px)",overflowY:"auto"}}>
                            {/* <React.Fragment> */}
                                <div style={{height : 20}}>
                                </div>
                                <FoldersPanel
                                    purchases_on_click={this.purchases_on_click}
                                    image_drag_start={this.image_drag_start}
                                    image_drag={this.image_drag}
                                    image_drag_end={this.image_drag_end}
                                    add_image={this.add_image}
                                />
                            </Row>
                        </Tab.Pane>
                    );

                    case 'bulk_edit' : return (
                        <Tab.Pane eventKey="bulk_edit">
                            <React.Fragment>
                                <BulkEditPanel label_rules={this.state.label_rules} design_selection={this.state.design_selection} labelOnSelect={() => this.setState({design_selection: null})} />
                            </React.Fragment>
                        </Tab.Pane>
                    );

                    case 'animations' : return (
                      <Tab.Pane eventKey="animations">
                          <Row style={{ width: "100%", height: "calc(100vh - 149px)", overflowY:"auto", paddingLeft: 15}}>
                              <Col xs={12} style={{ display : 'table', 'marginBottom' : 10, paddingTop : 5 }}>
                              </Col>
                              <AnimationsPanel design_selection={this.state.design_selection}/>
                          </Row>
                      </Tab.Pane>
                    );

                    case 'shadows' : return (
                        <Tab.Pane eventKey="shadows">
                            <Row style={{ width: "100%", height: "calc(100vh - 149px)", overflowY:"auto", paddingLeft: 0}}>
                                <Col xs={12} style={{ display : 'table', 'marginBottom' : 10, paddingTop : 5 }}>
                                </Col>
                                <ShadowsPanel design_selection={this.state.design_selection}/>
                            </Row>
                        </Tab.Pane>
                    )
                }
            } else {
                return '';
            }
        } catch(err) {
            console.log(err);
            return '';
        }
    }

    propagate_hover = async (id, value) => {
        try {
            this.set_state({ [id]: value })    
        } catch(err) {
            console.log(err);
        }
    }

    Hoverable_Icon = ({ hover_src, default_src, id, manual_hover }) => {
        try {
            const [ src, set_src ] = useState(null);

            const hover = () => {
                if (!manual_hover) {
                    set_src(hover_src);
                }
            }

            const un_hover = () => {
                if (!manual_hover) {
                    set_src(default_src);
                }
            }

            useEffect(() => {
                if (default_src) {
                    set_src(default_src);
                }
            }, [ default_src ])

            useEffect(() => {
                if (manual_hover) {
                    set_src(hover_src);
                } else {
                    set_src(default_src);
                }
            }, [ manual_hover ])

            return (
                <Image 
                    id={id}
                    style={{ height: 30 }} 
                    src={global.config.static_file_server_path + src} 
                    onMouseEnter={hover}
                    onMouseLeave={un_hover}
                />
            );
        } catch(err) {
            console.log('error in icon -__ > ', err);
            return '';
        }
    }

    animateOnClick = (type) => {
        this.setState({
            animationType : type
        }, () => this.switch_nav_tab("animations"));
    }

    toggle_share_switch_for_edit = () => {
        this.setState({ enable_share_switch_for_edit: !this.state.enable_share_switch_for_edit })
    }

    toggle_share_switch_for_view = () => {
        this.setState({ enable_share_switch_for_view: !this.state.enable_share_switch_for_view })
    }

    Dummy_Dropper = () => (<></>)

    alter_link_sharing = async () => {
        try {
            let action = null;
            if (this.state.link_sharing_enabled) {
                //disable link sharing
                action = 'disable';
            } else if (this.state.enable_share_switch_for_edit || this.state.enable_share_switch_for_view) {
                //enable link sharing
                action = this.state.enable_share_switch_for_edit ? 'enable_edit' : 'enable_view'
            } else {
                toastr.error('Please choose edit or view rights');
                return;
            }
            // console.log('link share action --> ', action);
            var data = await feline_fetch({ url: 'saved_design/alter_link_sharing', body: { design_id: this.state.design._id, action } })
            // console.log('share resp ===>> ', data);
            this.setState({ link_sharing_enabled: action == 'disable' ? false : true });
            toastr.success('Link Sharing ' + (this.state.link_sharing_enabled ? 'Enabled' : 'Disabled'))    
        } catch(err) {
            console.error(err);
            toastr.error('something went wrong')    
        }
    }

    render() {
        var {redirect, redirect_url} = this.state;

        if (redirect) {
            return (<Redirect push to={redirect_url} />)
        }

        if(this.props.match.params.role == 'view'){
            return (
                <div style={{backgroundColor: '#fafafa',height:'100vh',overflowY:'auto'}}>
                    <CanvasPages 
                        role="view"
                        view_display_srcs={this.state.view_display_srcs}
                        pages={this.state.pages}
                        set_pages={(n) => this.set_state({pages:n})}
                        rct_update_pages= {this.rct_update_pages}
                        design_save_id={this.state.design_save_id}
                        set_view_display_src={this.set_view_display_src}
                        design_file={this.state.design?this.state.design.design_file:null}
                        thumbnail={this.state.design?this.state.design.thumbnail:null}
                        set_default_category={this.set_default_category}
                        setDesignLoaded={this.setDesignLoaded}
                    />
                </div>
            );
        }


        const _text_options_panel = <TextOptionsPanel switch_nav_tab={this.switch_nav_tab} update_inputs_text={this.update_inputs_text} design_selection={this.state.design_selection} _rhs_options_panel={this._rhs_options_panel} _font_styles={fontStyles} _font_sizes={fontSizeOptions} textEffectsPanelOnclick={this.textEffectsPanelOnclick} animateOnClick={this.animateOnClick} />
        const _image_options_panel = <ImageOptionsPanel enter_crop_mode={this.enter_crop_mode} switch_nav_tab={this.switch_nav_tab} update_inputs_image={this.update_inputs_image} _rhs_options_panel={this._rhs_options_panel} design_selection={this.state.design_selection} adjustmentPanelOnclick={this.adjustmentPanelOnclick} backgroundRemovalPanelOnclick={this.backgroundRemovalPanelOnclick} toggle_background_removal={this.toggle_background_removal} mockupEditorPanelOnclick={this.mockupEditorPanelOnclick} animateOnClick={this.animateOnClick} shadowsPanelOnClick={this.shadowsPanelOnClick}/>
        const _background_options_panel = <BackgroundOptionsPanel enter_crop_mode={this.enter_crop_mode} switch_nav_tab={this.switch_nav_tab} update_inputs_background={this.update_inputs_background} design_selection={this.state.design_selection} design_editor={window.design_editor} adjustmentPanelOnclick={this.adjustmentPanelOnclick} backgroundRemovalPanelOnclick={this.backgroundRemovalPanelOnclick} toggle_background_removal={this.toggle_background_removal} mockupEditorPanelOnclick={this.mockupEditorPanelOnclick} animateOnClick={this.animateOnClick}/>
        const _group_options_panel = <GroupOptionsPanel switch_nav_tab={this.switch_nav_tab} _rhs_options_panel={this._rhs_options_panel} design_editor={window.design_editor} />

        /*
        Coupon related code
        const coupon_form = (
            <Form horizontal onSubmit={this.coupon_form_submit}>
                <FormGroup controlId="formHorizontalEmail">
                    <Col sm={9}>
                        <FormControl style={{"textTransform":"uppercase"}} type="text" onChange={event => this.update_inputs(event)} value={this.state.coupon_code ? this.state.coupon_code : null} name="coupon_code" placeholder="Apply Coupon" />
                    </Col>
                    <Col sm={3}>
                        <Button onClick={this.apply_coupon} className="btn btn-block btn-orange">Apply</Button>
                    </Col>
                </FormGroup>
            </Form>
        );

        const coupon_success = (
            <Row style={{fontFamily: 'Montserrat', fontWeight: 400}}>
                <Col sm={10} className="text-success success" style={{fontFamily: 'Montserrat', fontWeight: 400}}>
                    <span className="fa fa-check"> &nbsp;Coupon ({this.state.coupon_code && this.state.coupon_code.toUpperCase()}) Applied Successfully (Total discount - $ {this.state.discount})</span>
                </Col>
                <Col sm={2} style={{fontFamily: 'Montserrat'}}>
                    <Button className="btn btn-round btn-xs btn-danger" style={{float: 'left'}} onClick={this.remove_coupon}><span class="fa fa-times"></span></Button>
                </Col>
            </Row>
        );
         */

        const share_options = [{value: 'view', label: 'Can View'}, {value: 'edit', label: 'Can Edit'}];
        const share_link_options = [{value: 'none', label: 'Only shared emails can access this design'}, {value: 'view', label: 'Anyone with link can view'}, {value: 'edit', label: 'Anyone with link can edit'}];

        const user_options = []

        function autocompleteRenderInput ({addTag, ...props}) {
            const handleOnChange = (e, {newValue, method}) => {
                if (method === 'enter') {
                  e.preventDefault()
                } else {
                  props.onChange(e)
                }
            }

            const inputValue = (props.value && props.value.trim().toLowerCase()) || ''
            const inputLength = inputValue.length

            let suggestions = user_options.filter((user) => {
                return user.name.toLowerCase().slice(0, inputLength) === inputValue
            })

            return (
                <Autosuggest
                  ref={props.ref}
                  suggestions={suggestions}
                  shouldRenderSuggestions={(value) => value && value.trim().length > 0}
                  getSuggestionValue={(suggestion) => suggestion.name}
                  renderSuggestion={(suggestion) => <span>{suggestion.name}</span>}
                  inputProps={{...props, onChange: handleOnChange}}
                  onSuggestionSelected={(e, {suggestion}) => {
                    addTag(suggestion.name)
                  }}
                  onSuggestionsClearRequested={() => {}}
                  onSuggestionsFetchRequested={() => {}}
                />
            )
        }

        var share_popover = (
            <Popover id="share_popover" className="share_popover">
                <div>
                    <TagsInput renderInput={autocompleteRenderInput} value={this.state.share_emails} inputValue={this.state.last_email} inputProps={{placeholder: "Type one or more emails"}} onChange={this.handle_share_emails} onChangeInput={this.handle_last_email} />
                    <Select options={share_options} defaultValue={share_options[0]} onChange={(e)=>{this.setState({share_role:e.value})}}/>
                    <Button onClick={this.send_invites} className="popover-button-custom" style={{'width': '100%', marginTop: 5}} type="submit">Send Invites</Button>

                   {/* <div style={{width: '100%', marginTop: 10}}>Share Template</div>
                       {this.props.user?(
                           <Select options={share_link_options} defaultValue={share_options[0]} onChange={(e)=>{this.setState({share_role:e.value})}}/>
                       ):''}
                       {this.state.design && this.state.edit_all?(
                           <input type="text" style={{width: '100%', height: '32px', borderRadius: 4, border: '1px solid #cccccc', marginTop: 5}} value={this.state.design?(global.config.website_url + "designmaker/start/" + this.state.design._id + "/edit"):null}/>
                       ):""}
                       {this.state.design && this.state.view_all?(
                           <input type="text" style={{width: '100%', height: '32px', borderRadius: 4, border: '1px solid #cccccc', marginTop: 5}} value={this.state.design?(global.config.website_url + "designmaker/start/" + this.state.design._id + "/edit"):null}/>
                       ):""}*/}
                </div>
                <hr/>
                <div>
                    {this.state.link_sharing_enabled ? (
                        <>
                            <div>Link sharing is enabled for this design. Anyone with the link can <b>{this.state.enable_share_switch_for_edit ? 'edit' : 'view'}</b> it.</div>
                            <CopyLinkContainer 
                                link={global.config.website_url + "designmaker/start/designs/" + this.state.design._id + "/" + (this.state.enable_share_switch_for_edit ? 'edit' : 'view')}
                            />
                        </>
                    ) : (
                        <>
                            <Switcher 
                                title="Anyone with link can edit" 
                                show_dropper={this.state.enable_share_switch_for_edit} 
                                trigger_on_click={this.toggle_share_switch_for_edit} 
                                col_width_title={8} 
                                col_width_switch={4} 
                                Dropper={this.Dummy_Dropper}
                            />
                            <Switcher 
                                title="Anyone with link can view" 
                                show_dropper={this.state.enable_share_switch_for_view} 
                                trigger_on_click={this.toggle_share_switch_for_view} 
                                col_width_title={8} 
                                col_width_switch={4} 
                                Dropper={this.Dummy_Dropper}
                            />
                        </>
                    )}

                    <Button onClick={this.alter_link_sharing} className="popover-button-custom" style={{'width': '100%', marginTop: 5}} type="submit">{this.state.link_sharing_enabled ? "Disable Link Sharing" : "Enable Link Sharing"}</Button>

                   {/* <div style={{width: '100%', marginTop: 10}}>Share Template</div>
                       {this.props.user?(
                           <Select options={share_link_options} defaultValue={share_options[0]} onChange={(e)=>{this.setState({share_role:e.value})}}/>
                       ):''}
                       {this.state.design && this.state.edit_all?(
                           <input type="text" style={{width: '100%', height: '32px', borderRadius: 4, border: '1px solid #cccccc', marginTop: 5}} value={this.state.design?(global.config.website_url + "designmaker/start/" + this.state.design._id + "/edit"):null}/>
                       ):""}
                       {this.state.design && this.state.view_all?(
                           <input type="text" style={{width: '100%', height: '32px', borderRadius: 4, border: '1px solid #cccccc', marginTop: 5}} value={this.state.design?(global.config.website_url + "designmaker/start/" + this.state.design._id + "/edit"):null}/>
                       ):""}*/}
                </div>

            </Popover>
        )

        var zoom_popover = (
            <Popover id="zoom_popover" className="zoom_popover">
            <ListGroup>
                <ListGroupItem style={{fontWeight:'700',borderTop:'none',borderBottom:'none'}} onClick={() => this.set_zoom(300)}>300%</ListGroupItem>
                <ListGroupItem style={{fontWeight:'700',borderTop:'none',borderBottom:'none'}} onClick={() => this.set_zoom(200)}>200%</ListGroupItem>
                <ListGroupItem style={{fontWeight:'700',borderTop:'none',borderBottom:'none'}} onClick={() => this.set_zoom(125)}>125%</ListGroupItem>
                <ListGroupItem style={{fontWeight:'700',borderTop:'none',borderBottom:'none'}} onClick={() => this.set_zoom(100)}>100%</ListGroupItem>
                <ListGroupItem style={{fontWeight:'700',borderTop:'none',borderBottom:'none'}} onClick={() => this.set_zoom(75)}>75%</ListGroupItem>
                <ListGroupItem style={{fontWeight:'700',borderTop:'none',borderBottom:'none'}} onClick={() => this.set_zoom(50)}>50%</ListGroupItem>
                <ListGroupItem style={{fontWeight:'700',borderTop:'none',borderBottom:'none'}} onClick={() => this.set_zoom(25)}>25%</ListGroupItem>
                <ListGroupItem style={{fontWeight:'700',borderTop:'none',borderBottom:'none'}} onClick={() => this.set_zoom(10)}>10%</ListGroupItem>
                <ListGroupItem style={{fontWeight:'700',borderTop:'none',borderBottom:'none'}} onClick={() => this.set_zoom('fit')}>Fit</ListGroupItem>
                <ListGroupItem style={{fontWeight:'700',borderTop:'none',borderBottom:'none'}} onClick={() => this.set_zoom('fill')}>Fill</ListGroupItem>
            </ListGroup>
            </Popover>
        )

        const sidebar_style = {
            nav_text: {
                fontFamily: 'Montserrat',
                fontSize: 9,
                fontWeight: 500,
            },
            nav_item: {
                paddingLeft: 0,
                paddingRight: 0,
            }
        }

        if (this.state.device_type == "tablet") {
            console.log("DANGER _________________>>>>>>>>>>>>>>>>>>> Tablet");
            return (<Mobile_Deterrent/>);
        }


        return (
            <div style={{'fontFamily': 'Montserrat'}}>

                 <div id="full_page_loader" style={{display:(this.state.full_page_loader?'block':'none'), position:'fixed',width:'100%',height:'100%',backgroundColor:'rgba(100,100,100,0.5)',zIndex:'10000'}}>
                    <div style={{color:'white',fontSize:'20px',position:'absolute',left:'45%',top:'50%'}}>{this.state.full_page_loader_message}</div>
                </div>
                <div id="zoom_panel" style={{position: 'fixed',right: '20px',bottom: '10px',zIndex:'1010'}}>
                    <Panel style={{backgroundColor:'rgba(241, 242, 243, 0.8)',height:'40px',marginBottom:'0'}}>
                        <Row style={{fontWeight:'700'}}>
                            <OverlayTrigger onClick={this.toggle_overlay_zoom} trigger="click" placement="top" overlay={zoom_popover}>
                                <Col id="overlay_button_zoom" xs={12} style={{cursor:'pointer',paddingTop: '10px',height:'40px'}} className="hover-grey">
                                    {this.state.page_zoom_display}
                                </Col>
                            </OverlayTrigger>
                            {/*<Col xs={6} style={{paddingTop: '10px',height:'40px'}} className="hover-grey">
                                                            <span className='fa fa-expand'></span>
                                                        </Col>*/}
                        </Row>
                    </Panel>
                </div>
                <UnifiedCheckoutModal show={this.state.showUnifiedCheckoutModal} onHide ={this.hideUnifiedCheckoutModal} src={this.state.checkoutUrl}/>
                <SubscriptionModal show={this.state.displaySubscriptionModal} hide={() => this.setSubscriptionModalDisplay(false)}/>
                <DMPlayerModal show={this.state.display_animations_player_modal} hide = {this.closeAnimationsPlayerModal}/>
                <ShareLinkModal 
                    show_share_modal={this.state.show_share_modal}
                    hide_share_modal={() => this.setState({ show_share_modal: false })}
                    // design_id={this.state.design?._id ?? null}
                    // #TODO: New syntax not supported, create-react-app to be updated to ~3.3.*
                    design_id={this.state.design? this.state.design._id : null}
                    is_saved_design
                />
                <div id="popover_overlay_share" style={{top: 0, left: 0, position: "fixed", zIndex: "1000", height: "100%", width: "100%", display: "none"}} onClick={() => document.getElementById('overlay_button_share').click()}></div>
                <div id="popover_overlay_zoom" style={{top: 0, left: 0, position: "fixed", zIndex: "1000", height: "100%", width: "100%", display: "none"}} onClick={() => document.getElementById('overlay_button_zoom').click()}></div>
                <SuggestDesignsModal show_suggest_design_modal={this.state.show_suggest_design_modal} hide_suggest_design_modal={this.hide_suggest_design_modal} triggerSubscriptionWall={hasAutoSuggestPerm(this.props.user)?null:this.setSubscriptionModalDisplay}/>
                <MagicResizeModal show_magic_resize_modal={this.state.show_magic_resize_modal} hide_magic_resize_modal={this.hide_magic_resize_modal} triggerSubscriptionWall={hasMagicResizePerm(this.props.user)?null:this.setSubscriptionModalDisplay}/>
                <Row style={{'padding': '10px', 'backgroundColor': '#ffffff', zIndex: 1020, boxShadow: '0 2px 16px 0 rgba(177,177,177,0.5)', position: 'relative'}} className='editor_div'>
                    <Col xs={3} style={{paddingLeft:0,textAlign: 'left', width: 382}}>
                        <Button onClick={this.back_onclick} className="top-nav-buttons" style={{float: 'left', 'color' : 'black !important',marginLeft:'5px'}}><span ><Image style={{height:'28px'}} src={window.__PUBLIC_URL + "/icons/back.svg"}></Image></span></Button>
                        <input className="design-name" style={{marginLeft : 30,paddingLeft:5, marginTop: 5}} type='text' placeholder={this.state.designName} onFocus={(e) => {e.target.value = this.state.designName} } onKeyDown={this.setDesignNameEnter} onChange={this.setDesignName} onBlur={() => update_design_name(this.props.match.params.design_id, this.state.designName)}></input>
                        <span></span>
                    </Col>
                    <Col xs={9} style={{'fontWeight': 'bold', 'fontSize' : 'large', 'fontFamily': 'Montserrat', width: 'calc(100% - 382px)'}}>
                        {this.is_admin_designs()||this.is_admin_text_templates()?(<div style={{"float": "left"}}>
                            <LabellingToolBar label_rules={this.state.label_rules} design_selection={this.state.design_selection} />
                        </div>):null}
                        <div style={{ float: 'left'}}>
                            <DesignSaveStatus />
                            <Button id="design_editor_undo_button" onClick={this.design_undo} className="top-nav-buttons" style={{'color' : '#00000 !important'}}><span><Image style={{height: 30}} src={global.config.static_file_server_path + 'uploads/icons/undo_new.svg'}></Image></span></Button>
                            <Button id="design_editor_redo_button" onClick={this.design_redo} className="top-nav-buttons" style={{'color' : '#00000 !important',marginRight:20}}><span><Image style={{height: 30}} src={global.config.static_file_server_path + 'uploads/icons/redo_new.svg'}></Image></span></Button>
                        </div>
                        <div style={{"float": "right"}}>
                            {!this.is_admin_designs()&&!this.is_admin_text_templates() && (<Button className="btn-grey-inverse btn-header" style={{ paddingTop: 6, paddingBottom: 6, fontWeight: 500, marginTop: 3, marginRight: 5, border: 'none'}} onClick={() => this.setState({display_animations_player_modal: true})}>Play</Button>)}
                            {!this.is_admin_designs()&&!this.is_admin_text_templates() && (<Button className="btn-grey-inverse btn-header" style={{ paddingTop: 6, paddingBottom: 6, fontWeight: 500, marginTop: 3, marginRight: 5, border: 'none'}} onClick={this.enterMagicResize}>Resize</Button>)}

                            {/*!this.is_admin_designs()&&!this.is_admin_text_templates() && (<Button className="btn-orange-inverse btn-header" style={{ paddingTop: 6, paddingBottom: 6, fontWeight: 500, marginTop: 3, marginRight: 5}} onClick={this.enterSuggestMode}>Swap</Button>)*/}

                            {/*!this.is_admin_designs()&&!this.is_admin_text_templates() && (
                                <Button className='btn-orange-inverse btn-header' style={{ paddingTop: 6, paddingBottom: 6, fontWeight: 500, marginTop: 3, marginRight: 5}} onClick={() => {window.design_editor.save_backend().then(o => {toastr.success('Design saved successfully')}).catch(err => {toastr.error('Design couldn\'t be saved')}) }}> Save </Button>
                            )*/}


                            <Button className='btn-grey-inverse btn-header' style={{ paddingTop: 6, paddingBottom: 6, fontWeight: 500, marginTop: 3, marginRight: 5, border: 'none'}} onClick={() => {window.design_editor.present();}}> Present </Button>
                            {!this.is_admin_designs()&&!this.is_admin_text_templates() && this.props.user && (
                                // <span><OverlayTrigger trigger="click" placement="bottom" overlay={share_popover}>
                                <Button id="overlay_button_share" className="btn-grey-inverse btn-header" style={{ paddingTop: 6, paddingBottom: 6, fontWeight: 500, marginTop: 3, marginRight:5, border: 'none'}} onClick={() => this.setState({ show_share_modal: true })}>Share</Button>
                                // </OverlayTrigger></span>
                            )}
                            {!this.is_admin_designs() &&!this.is_admin_text_templates() && this.props.user  && (
                                <OverlayTrigger
                                    ref="purchase_modal_overlay"
                                    rootClose
                                    trigger="click"
                                    placement="bottom"
                                    overlay={
                                        <Popover {...this.props}
                                                 className="download-popover"
                                                 id="download-popover"
                                                 positionLeft={-20}
                                        >
                                            <PurchaseModal show={this.state.showPurchaseModal} hide={this.hidePurchaseModal} export_design={this.export_design} designId={this.props.match.params.design_id} showUnifiedCheckoutModal={(url) => this.setState({showUnifiedCheckoutModal: true, checkoutUrl: url})} hideUnifiedCheckoutModal={this.hideUnifiedCheckoutModal}/>
                                        </Popover>
                                    }
                                    onClick={() => this.setState({showPurchaseModal: true})}
                                >
                                    <Button id="overlay_button_download" className='btn-orange-inverse' style={{ paddingTop: 6, paddingBottom: 6, fontWeight: 500, marginTop: 3, marginRight:5}}> Download </Button>
                                </OverlayTrigger>
                            )}

                            {!this.is_admin_designs() &&!this.is_admin_text_templates() && !this.props.user  && (
                                <Button id="overlay_button_download" onClick={this.inmagine_login} className='btn-orange-inverse' style={{ paddingTop: 6, paddingBottom: 6, fontWeight: 500, marginTop: 3, marginRight:5}}> Download </Button>
                            )}
                            

                            {this.is_admin_text_templates() && this.state.design_selection && (this.state.design_selection.getGroup()||this.state.design_selection.type == 'group') && ( <Button className='btn-purple' onClick={this.save_text_template_admin}> Save Text Template </Button>)}
                            {this.is_admin_designs() && ( <Button className='btn-purple' onClick={this.save_design_template_admin}> Save Design Template </Button>)}
                        </div>

                    </Col>
                </Row>
                {/* <div className={this.state.collapse_sidebar ? "sidebar_open" : "sidebar_close"} onClick={this.close_sidebar}><span className={this.state.collapse_sidebar ? "fas fa-chevron-right fa-2x" : "fas fa-chevron-left fa-2x"} /></div> */}
                <div className="sidebar_container" style={{height:'calc(100vh - 60px)', display: 'flex', flexDirection: 'row'}}>
                    <div className='text-center' style={{width : this.state.collapse_sidebar ? 78 : 388,padding:'0', zIndex: 100, boxShadow: '0 2px 16px 0 #C5C5C5'}}>
                        <div style={{height: '100%', 'padding' : '0px'}}>
                            <Tab.Container id="tab_container_id" activeKey={this.state.active_nav_tab ? this.state.active_nav_tab : this.state.collapse_sidebar ? null : "templates"} onSelect={this.switch_nav_tab}>
                                <div style={{height: '100%', display: 'flex', flexDirection: 'row' }}>
                                    <div id="design_sidebar" style={{'paddingBottom':'15px',borderBottom:"1px solid #cccccc", width: 78, height: '100%', backgroundColor: 'white', overflowY: 'auto' }}>
                                        <Nav role="tablist" stacked >
                                            <NavItem 
                                                onMouseEnter={() => this.propagate_hover('hoverable_icon_template', true)} 
                                                onMouseLeave={() => this.propagate_hover('hoverable_icon_template', false)} 
                                                className="design_resources_nav_items" 
                                                eventKey="templates"
                                            >
                                                <span style={sidebar_style.nav_text}><span />
                                                <this.Hoverable_Icon 
                                                    id={'hoverable_icon_template'}
                                                    manual_hover={this.state.hoverable_icon_template}
                                                    default_src={this.state.active_nav_tab && this.state.active_nav_tab == 'templates' ? 'uploads/icons/Template_white.svg' : 'uploads/icons/Template.svg'} 
                                                    hover_src={'uploads/icons/Template_white.svg'} 
                                                />
                                                <br/><br/>Templates</span>
                                            </NavItem>
                                            <NavItem 
                                                onMouseEnter={() => this.propagate_hover('hoverable_icon_photo', true)} 
                                                onMouseLeave={() => this.propagate_hover('hoverable_icon_photo', false)} 
                                                className="design_resources_nav_items" 
                                                eventKey="photos"
                                            >
                                                <span style={sidebar_style.nav_text}><span />
                                                <this.Hoverable_Icon 
                                                    id={'hoverable_icon_photo'}
                                                    manual_hover={this.state.hoverable_icon_photo}
                                                    default_src={this.state.active_nav_tab && this.state.active_nav_tab == 'photos' ? 'uploads/icons/Photos_white.svg' : 'uploads/icons/Photos.svg'} 
                                                    hover_src={'uploads/icons/Photos_white.svg'} 
                                                />
                                                <br/><br/>Photos</span>
                                            </NavItem>
                                            <NavItem 
                                                onMouseEnter={() => this.propagate_hover('hoverable_icon_background', true)} 
                                                onMouseLeave={() => this.propagate_hover('hoverable_icon_background', false)} 
                                                className="design_resources_nav_items" 
                                                eventKey="backgrounds"
                                            >
                                                <span style={sidebar_style.nav_text}><span />
                                                <this.Hoverable_Icon 
                                                    id={'hoverable_icon_background'}
                                                    manual_hover={this.state.hoverable_icon_background}
                                                    default_src={this.state.active_nav_tab && this.state.active_nav_tab == 'backgrounds' ? 'uploads/icons/Background_white.svg' : 'uploads/icons/Background.svg'} 
                                                    hover_src={'uploads/icons/Background_white.svg'} 
                                                />
                                                <br/><br/>Backgrounds</span>
                                            </NavItem>
                                            <NavItem 
                                                onMouseEnter={() => this.propagate_hover('hoverable_icon_text', true)} 
                                                onMouseLeave={() => this.propagate_hover('hoverable_icon_text', false)} 
                                                className="design_resources_nav_items" 
                                                eventKey="text"
                                            >
                                                <span style={sidebar_style.nav_text}><span />
                                                <this.Hoverable_Icon 
                                                    id={'hoverable_icon_text'}
                                                    manual_hover={this.state.hoverable_icon_text}
                                                    default_src={this.state.active_nav_tab && this.state.active_nav_tab == 'text' ? 'uploads/icons/Text_white.svg' : 'uploads/icons/Text.svg'} 
                                                    hover_src={'uploads/icons/Text_white.svg'} 
                                                />
                                                <br/><br/>Text</span>
                                            </NavItem>
                                            <NavItem 
                                                onMouseEnter={() => this.propagate_hover('hoverable_icon_element', true)} 
                                                onMouseLeave={() => this.propagate_hover('hoverable_icon_element', false)} 
                                                className="design_resources_nav_items" 
                                                eventKey="elements"
                                            >
                                                <span style={sidebar_style.nav_text}><span />
                                                <this.Hoverable_Icon 
                                                    id={'hoverable_icon_element'}
                                                    manual_hover={this.state.hoverable_icon_element}
                                                    default_src={this.state.active_nav_tab && this.state.active_nav_tab == 'elements' ? 'uploads/icons/Elements_white.svg' : 'uploads/icons/Elements.svg'} 
                                                    hover_src={'uploads/icons/Elements_white.svg'} 
                                                />
                                                <br/><br/>Elements</span>
                                            </NavItem>
                                            <NavItem 
                                                onMouseEnter={() => this.propagate_hover('hoverable_icon_mockup', true)} 
                                                onMouseLeave={() => this.propagate_hover('hoverable_icon_mockup', false)} 
                                                className="design_resources_nav_items" 
                                                eventKey="mockups"
                                            >
                                                <span style={sidebar_style.nav_text}><span />
                                                <this.Hoverable_Icon 
                                                    id={'hoverable_icon_mockup'}
                                                    manual_hover={this.state.hoverable_icon_mockup}
                                                    default_src={this.state.active_nav_tab && this.state.active_nav_tab == 'mockups' ? 'uploads/icons/Mockup_white.svg' : 'uploads/icons/Mockup.svg'} 
                                                    hover_src={'uploads/icons/Mockup_white.svg'} 
                                                />
                                                <br/><br/>Mockups</span>
                                            </NavItem>
                                            <NavItem 
                                                onMouseEnter={() => this.propagate_hover('hoverable_icon_animations', true)} 
                                                onMouseLeave={() => this.propagate_hover('hoverable_icon_animations', false)} 
                                                className="design_resources_nav_items" 
                                                eventKey="animations"
                                            >
                                                <span style={sidebar_style.nav_text}><span />
                                                <this.Hoverable_Icon 
                                                    id={'hoverable_icon_animations'}
                                                    manual_hover={this.state.hoverable_icon_animations}
                                                    default_src={this.state.active_nav_tab && this.state.active_nav_tab == 'animations' ? 'uploads/icons/Animation_white.svg' : 'uploads/icons/Animation.svg'} 
                                                    hover_src={'uploads/icons/Animation_white.svg'} 
                                                />
                                                <br/><br/>Animate</span>
                                            </NavItem>
                                            <NavItem 
                                                onMouseEnter={() => this.propagate_hover('hoverable_icon_brand_kit', true)} 
                                                onMouseLeave={() => this.propagate_hover('hoverable_icon_brand_kit', false)} 
                                                className="design_resources_nav_items" 
                                                eventKey="brand_kit"
                                            >
                                                <span style={sidebar_style.nav_text}><span />
                                                <this.Hoverable_Icon 
                                                    id={'hoverable_icon_brand_kit'}
                                                    manual_hover={this.state.hoverable_icon_brand_kit}
                                                    default_src={this.state.active_nav_tab && this.state.active_nav_tab == 'brand_kit' ? 'uploads/icons/BrandKit_White.svg' : 'uploads/icons/BrandKit.svg'} 
                                                    hover_src={'uploads/icons/BrandKit_White.svg'} 
                                                />
                                                <br/><br/>Brand Kit</span>
                                            </NavItem>
                                            <NavItem
                                                onMouseEnter={() => this.propagate_hover('hoverable_icon_uploads', true)}
                                                onMouseLeave={() => this.propagate_hover('hoverable_icon_uploads', false)}
                                                className="design_resources_nav_items"
                                                eventKey="uploads"
                                            >
                                                <span style={sidebar_style.nav_text}><span />
                                                <this.Hoverable_Icon
                                                    id={'hoverable_icon_uploads'}
                                                    manual_hover={this.state.hoverable_icon_uploads}
                                                    default_src={this.state.active_nav_tab && this.state.active_nav_tab === 'uploads' ? 'uploads/icons/Upload_white.svg' : 'uploads/icons/Upload.svg'}
                                                    hover_src={'uploads/icons/Upload_white.svg'}
                                                />
                                                <br/><br/>Uploads</span>
                                            </NavItem>
                                            <NavItem
                                                onMouseEnter={() => this.propagate_hover('hoverable_icon_bulk_edit', true)}
                                                onMouseLeave={() => this.propagate_hover('hoverable_icon_bulk_edit', false)}
                                                className="design_resources_nav_items"
                                                eventKey="bulk_edit"
                                            >
                                                <span style={sidebar_style.nav_text}><span />
                                                <this.Hoverable_Icon
                                                    id={'hoverable_icon_bulk_edit'}
                                                    manual_hover={this.state.hoverable_icon_bulk_edit}
                                                    default_src={this.state.active_nav_tab && this.state.active_nav_tab === 'bulk_edit' ? 'uploads/icons/BulkEdit_white.svg' : 'uploads/icons/BulkEdit.svg'}
                                                    hover_src={'uploads/icons/BulkEdit_white.svg'}
                                                />
                                                <br/><br/>Bulk Edit</span>
                                            </NavItem>
                                            <NavItem 
                                                onMouseEnter={() => this.propagate_hover('hoverable_icon_folder', true)} 
                                                onMouseLeave={() => this.propagate_hover('hoverable_icon_folder', false)} 
                                                className="design_resources_nav_items" 
                                                eventKey="folders"
                                            >
                                                <span style={sidebar_style.nav_text}><span />
                                                <this.Hoverable_Icon 
                                                    id={'hoverable_icon_folder'}
                                                    manual_hover={this.state.hoverable_icon_folder}
                                                    default_src={this.state.active_nav_tab && this.state.active_nav_tab == 'folders' ? 'uploads/icons/Folders_white.svg' : 'uploads/icons/Folders.svg'} 
                                                    hover_src={'uploads/icons/Folders_white.svg'} 
                                                />
                                                <br/><br/>Folders</span>
                                            </NavItem>
                                            {/* <NavItem className="design_resources_nav_items" eventKey="text"> */}
                                            {/*     <span style={sidebar_style.nav_text}><span /><Image style={{height:'30px'}} src={global.config.static_file_server_path+'uploads/icons/Text.svg'} /><br/><br/>Text</span> */}
                                            {/* </NavItem> */}
                                            {/* <NavItem className="design_resources_nav_items" eventKey="elements"> */}
                                            {/*     <span style={sidebar_style.nav_text}><span /><Image style={{height:'30px'}} src={global.config.static_file_server_path+'uploads/icons/Elements.svg'} /><br/><br/>Elements</span> */}
                                            {/* </NavItem> */}
                                            {/* <NavItem className="design_resources_nav_items" eventKey="mockups"> */}
                                            {/*     <span style={sidebar_style.nav_text}><span /><Image style={{height:'30px'}} src={global.config.static_file_server_path+'uploads/icons/Mockup.svg'} /><br/><br/>Mockups</span> */}
                                            {/* </NavItem> */}
                                            {/* <NavItem className="design_resources_nav_items" eventKey="folders"> */}
                                            {/*     <span style={sidebar_style.nav_text}><span /><Image style={{height:'30px'}} src={global.config.static_file_server_path+'uploads/icons/Folders.svg'} /><br/><br/>Folders</span> */}
                                            {/* </NavItem> */}

                                        </Nav>
                                    </div>
                                    <div style={{width: 310, height: '100%', backgroundColor: '#white', display: this.state.collapse_sidebar ? 'none' : 'block', paddingLeft: 2, paddingRight: 8 }}>
                                        {[ 'photos', 'brand_kit', 'templates', 'elements', 'backgrounds', 'text', 'uploads', 'mockups','animate', 'folders', 'filters', 'adjust','text_effects', 'fonts','remove_background','mockup_editor', 'bulk_edit', 'shadows'].includes(this.state.active_nav_tab) ? (<div style={{ textAlign: 'left', height: 92, paddingTop: 32, color: '#888888', fontFamily: 'Montserrat', fontSize: 21, fontWeight: 600, paddingLeft: 30, paddingRight: 15, width: '100%' }}>
                                            {capFirst(this.state.active_nav_tab)}
                                            <span onClick={this.close_sidebar} style={{ cursor: 'pointer', float: 'right', marginTop: 3 }} className="fa fa-arrow-left fa-light" />
                                        </div>) : ''}
                                        {this.state.active_nav_tab === 'animations' ?
                                            (<div style={{ textAlign: 'left', height: 92, paddingTop: 32, color: '#888888', fontFamily: 'Montserrat', fontSize: 21, fontWeight: 600, paddingLeft: 30, paddingRight: 15, width: '100%' }}>
                                                {"Animations"}
                                                {/*{this.state.animationType === "element" ? "Element animation" : (this.state.animationType === "text" ? "Text animation" : "Page animations")}*/}
                                            <span onClick={this.close_sidebar} style={{ cursor: 'pointer', float: 'right', marginTop: 3 }} className="fa fa-arrow-left fa-light" />
                                        </div>) : ''}
                                        <div style={{width: '100%', height: 'calc(100% - 92px)', backgroundColor: '#EDEDED', display: this.state.collapse_sidebar ? 'none' : 'block', paddingLeft: 1, borderRadius: 3, overflowY: 'hidden' }}>
                                            <Tab.Content animation={false}>
                                                {this.state.active_nav_tab == 'text'?(
                                                <div className="nav_content_search_container" style={{padding: 12, paddingTop: 20}}>
                                                    <Form onSubmit={this.fetch_search_results}>
                                                        <FormGroup>
                                                            <InputGroup style={{width: "100%"}}>
                                                                <FormControl style={{fontSize: 14, fontFamily: 'Montserrat', height: 42, borderRadius: 4}} placeholder= {'Search ' + this.state.active_nav_tab} value={this.state.search_text} type="text" onChange={(e) => this.handle_design_resources_search(e)}/>
                                                                {this.state.search_active ?
                                                                    (<span onClick={() => this.setState({search_active: false, search_text: ''})} style={{cursor: 'pointer', position: 'absolute', right: 12, top: 9, fontSize: 22, zIndex: 100, color: '#C8CDD4'}} className="fas fa-times fa-2x fas-light" />)
                                                                    : (<span onClick={this.fetch_search_results} style={{position: 'absolute', cursor: 'pointer', right: 12, top: 9, fontSize: 22, zIndex: 100, color: '#C8CDD4'}} className="fas fa-search fa-2x fas-light" />)
                                                                }
                                                            </InputGroup>
                                                            <Button style={{'display': 'none'}} type='submit'></Button>
                                                        </FormGroup>
                                                    </Form>
                                                </div>): ''}
                                                <this.AllTabs />
                                            </Tab.Content>
                                        </div>
                                    </div>
                                </div>
                            </Tab.Container>
                        </div>
                    </div>
                    <div style={{display:'flex','flexFlow':'column',padding:"0", 'width': this.state.collapse_sidebar ? 'calc(100% - 78px)' : 'calc(100% - 388px)','height':'100%'}}>
                        {this.state.crop_mode?this._crop_mode_options_panel():''}
                        {!this.state.crop_mode&&this.state.toolbar_type=='text'?_text_options_panel:''}
                        {!this.state.crop_mode&&this.state.toolbar_type=='grid'?this._grid_options_panel():''}
                        {!this.state.crop_mode&&this.state.toolbar_type=='image'? _image_options_panel:''}
                        {!this.state.crop_mode&&this.state.toolbar_type=='background'? _background_options_panel:''}
                        {!this.state.crop_mode&&this.state.toolbar_type=='group'? _group_options_panel:''}
                        {!this.state.crop_mode&&!this.state.toolbar_type&&(<Row className="d-flex align-items-center" style={{paddingTop:"50px", backgroundColor: '#F1F2F3', zIndex :1010}}></Row>)}
                        <div id="design_doms_parent" style={{position:'relative',display:'flex','flexFlow':'column',overflow:'auto',padding:"0",height:"calc(100% + 50px)"}}>
                            <CanvasPages
                                role="edit" 
                                view_display_srcs={this.state.view_display_srcs}
                                pages={this.state.pages}
                                set_pages={(n) => this.set_state({pages:n})}
                                rct_update_pages= {this.rct_update_pages}
                                design_save_id={this.state.design_save_id}
                                set_view_display_src={this.set_view_display_src}
                                design_file={this.state.design?this.state.design.design_file:null}
                                thumbnail={this.state.design?this.state.design.thumbnail:null}
                                set_default_category={this.set_default_category}
                                setDesignLoaded={this.setDesignLoaded}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );

    }
}

const mapStateToProps = function(state) {
    return {
        user: state.user,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        calculate_price: (price, code) => {
            return dispatch(calculate_price(price, code))
        },

        fetch_design_template: (id) => {
            return dispatch(fetch_design_template(id))
        },

        fetch_text_template: (id) => {
            return dispatch(fetch_text_template(id))
        },

        fetch_saved_design: (id) => {
            return dispatch(fetch_saved_design(id))
        },

        share_permission_with_emails: (host_email,emails,saved_design,role) => {
            return dispatch(share_permission_with_emails(host_email,emails,saved_design,role))
        },
        check_permission: (user_email,saved_design,role) => {
            return dispatch(check_permission(user_email,saved_design,role))
        }
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Designs))